<template>
  <v-layout row justify-center align-start v-resize="getDimensions">
    <v-flex>
      <div
        style="position: absolute; visibility: hidden"
        class="qrcode"
        ref="qrCodeUrl"
      ></div>

      <v-card :height="isMobile ? height - 100 : height - 100">
        <v-system-bar
          dark
          color="error"
          lights-out
          v-if="!searchCodClienteFlag"
        >
          <v-icon> fa-solid fa-xmark </v-icon>
          <v-spacer></v-spacer>
          No hay talonarios asignados al usuario
        </v-system-bar>
        <v-app-bar color="white" elevate-on-scroll flat>
          <v-spacer></v-spacer>
          <div v-if="showSearchCliente">
            <v-text-field
              outlined
              dense
              v-model="searchCodCliente"
              @click:prepend="typeSearchCliente = !typeSearchCliente"
              @click:append="clearSearchCliente"
              
              :label="
                typeSearchCliente
                  ? 'Búsqueda por código'
                  : 'Búsqueda por nombre'
              "
              color="icons"
              hide-details
              append-icon="fa-solid fa-xmark"
              :prepend-icon="
                typeSearchCliente ? 'fa-solid fa-list-ol' : 'fa-solid fa-user'
              "
              hint="Pulse el botón a la izquierda para cambiar el tipo de búsqueda"
            ></v-text-field>
          </div>
          <div v-else>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  large
                  @click="showSearchCliente = !showSearchCliente"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark>
                    {{ showSearchCliente ? "search_off" : "search" }}
                  </v-icon>
                </v-btn>
              </template>
              <span>{{
                showSearchCliente
                  ? "Ocultar filtros de búsqueda"
                  : "Mostrar filtros de búsqueda"
              }}</span>
            </v-tooltip>
          </div>
        </v-app-bar>
        <v-progress-linear
          :active="loadCliente"
          :indeterminate="loadCliente"
          absolute
          top
          color="primary"
        ></v-progress-linear>

        <v-sheet
          class="overflow-y-auto"
          :max-height="isMobile ? height - 130 : height - 120"
        >
          <v-card class="mx-auto" :max-width="width">
            <v-list v-if="loadCliente">
              <v-skeleton-loader
                v-for="n in 7"
                :key="n"
                type="list-item-avatar-three-line"
              />
            </v-list>

            <v-list two-line v-else>
              <v-list-item-group v-model="selectedCliente" active-class="">
                <v-virtual-scroll
                  :items="dtCliente"
                  :height="height - 170"
                  item-height="130"
                >
                  <template v-slot:default="{ item }">
                    <v-list-item :key="item.id">
                      <template v-slot:default="{ active }">
                        <v-list-item-action v-if="item.cantidad_documento > 0">
                          <v-badge
                            color="error"
                            :content="item.cantidad_documento"
                          >
                            <v-icon :color="item.color">
                              fa-solid fa-store
                            </v-icon>
                          </v-badge>
                        </v-list-item-action>
                        <v-list-item-avatar v-else>
                          <v-icon :color="item.color">
                            fa-solid fa-store
                          </v-icon>
                        </v-list-item-avatar>

                        <v-list-item-content>
                          <v-list-item-title
                            :class="'font-weight-bold ' + item.color + '--text'"
                          >
                            {{ item.codigo }} ( {{ item.categoria_cliente }})
                          </v-list-item-title>
                          <v-list-item-title
                            :class="'font-weight-bold ' + item.color + '--text'"
                          >
                            {{ item.descripcion }}
                          </v-list-item-title>

                          <v-list-item-subtitle class="caption">
                            {{ item.razon_social }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle class="caption">
                            Nit: {{ item.nit }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle v-if="!active" class="caption">
                            Sucursal: {{ item.departamento }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle
                            v-if="!active"
                            :class="'caption ' + item.color + '--text'"
                          >
                            Forma Pago: {{ item.forma_pago }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle v-if="active">
                            <v-btn
                              v-if="rol !== 'REP'"
                              class="mx-2"
                              fab
                              dark
                              small
                              color="blue"
                              @click="actualizarCliente(item)"
                            >
                              <v-icon dark
                                >fa-solid fa-address-card
                              </v-icon> </v-btn
                            ><v-btn
                              class="mx-2"
                              fab
                              dark
                              small
                              color="secondary"
                              @click="showListRecibo(active, item)"
                            >
                              <v-icon dark> fa-solid fa-list-ul </v-icon>
                            </v-btn>
                            <v-btn
                              class="mx-2"
                              fab
                              dark
                              small
                              color="primary"
                              @click="addValor('T', item)"
                            >
                              <v-icon dark
                                >fa-solid fa-money-bill-transfer
                              </v-icon>
                            </v-btn>

                            <v-btn
                              class="mx-2"
                              fab
                              dark
                              small
                              color="success"
                              @click="addRecibo(item)"
                            >
                              <v-icon dark>fa-solid fa-plus </v-icon>
                            </v-btn>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </v-list-item>
                  </template>
                </v-virtual-scroll>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-sheet>
      </v-card>

      <v-dialog
        v-model="dialogAlpha"
        persistent
        :retain-focus="false"
        :fullscreen="isMobile"
        max-width="500px"
        transition="dialog-bottom-transition"
      >
        <v-layout align-start v-resize="getDimensions">
          <v-flex>
            <v-card ref="form" :height="isMobile ? height - 75 : height - 100">
              <v-app-bar color="white" elevate-on-scroll flat>
                <v-card-title v-if="!showSearchRecibo">
                  <span class="headline">Recibos</span>
                </v-card-title>

                <v-spacer></v-spacer>
                <div v-if="showSearchRecibo">
                  <v-text-field
                    color="icons"
                    outlined
                    dense
                    v-model="searchRecibo"
                    @click:append="showSearchRecibo = !showSearchRecibo"
                    label="Búsqueda de Recibos"
                    hide-details
                    append-icon="fa-solid fa-xmark"
                    prepend-icon="search"
                    hint="Pulse el botón a la izquierda para cambiar el tipo de búsqueda"
                  ></v-text-field>
                </div>
                <div v-else>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        large
                        @click="showSearchRecibo = !showSearchRecibo"
                        color="icons"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark>
                          {{ showSearchRecibo ? "search_off" : "search" }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{
                      showSearchRecibo
                        ? "Ocultar filtros de búsqueda"
                        : "Mostrar filtros de búsqueda"
                    }}</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        @click="closeListRecibo"
                        color="icons"
                        v-bind="attrs"
                        v-on="on"
                        fab
                      >
                        <v-icon dark> close </v-icon>
                      </v-btn>
                    </template>
                    <span>Cancelar</span>
                  </v-tooltip>
                </div>
              </v-app-bar>
              <v-card :height="isMobile ? height - 57 : height - 170">
                <v-sheet
                  class="overflow-y-auto"
                  :max-height="isMobile ? height - 60 : height - 160"
                >
                  <v-card class="mx-auto" :max-width="width">
                    <v-list two-line>
                      <v-list-item-group
                        v-model="selectedRecibo"
                        active-class="blue--text"
                      >
                        <v-virtual-scroll
                          :items="filtrarDtRecibo"
                          :height="height - 150"
                          item-height="83"
                        >
                          <template v-slot:default="{ item }">
                            <v-list-item :key="item.id">
                              <template v-slot:default="{ active }">
                                <v-list-item-avatar>
                                  <div>
                                    <v-tooltip bottom>
                                      <template
                                        v-slot:activator="{ on, attrs }"
                                      >
                                        <viewer>
                                          <img
                                            :src="item.foto_recibo"
                                            class="image"
                                            v-bind="attrs"
                                            v-on="on"
                                          />
                                        </viewer>
                                      </template>
                                      <span>{{ "Ver Imagen" }}</span>
                                    </v-tooltip>
                                  </div>
                                </v-list-item-avatar>
                                <v-list-item-content @click="showRecibo(item)">
                                  <v-list-item-title class="font-weight-bold">
                                    Recibo N° {{ item.numero_recibo }}
                                  </v-list-item-title>

                                  <v-list-item-subtitle class="text--primary">
                                    {{ $formatoFechaHoras(item.fecha) }}
                                  </v-list-item-subtitle>

                                  <v-list-item-subtitle class="caption">
                                    {{ item.descripcion }}
                                  </v-list-item-subtitle>
                                  <v-list-item-action-text
                                    :class="
                                      item.estado === 'B'
                                        ? 'error--text'
                                        : 'black--text'
                                    "
                                  >
                                    Estado:
                                    {{
                                      item.estado === "A"
                                        ? "Creado"
                                        : item.estado === "C"
                                        ? "Respaldado"
                                        : item.estado === "P"
                                        ? "Por Rendir"
                                        : item.estado === "B"
                                        ? "Anulado"
                                        : item.estado === "R"
                                        ? "Rendido"
                                        : item.estado === "V"
                                        ? "Verificado"
                                        : item.estado === "AA"
                                        ? "Anulado SAC"
                                        : item.estado === "E"
                                        ? "Procesado con Error SAC"
                                        : item.estado === "I"
                                        ? "Importado SAC"
                                        : item.estado === "J"
                                        ? "Para aprobar SAC"
                                        : item.estado === "N"
                                        ? "Importando SAC"
                                        : item.estado === "O"
                                        ? "Aprobado NETORDER"
                                        : item.estado === "PP"
                                        ? "Procesado Ok SAC"
                                        : item.estado === "RR"
                                        ? "Registrado SAC"
                                        : item.estado === "U"
                                        ? "Importado en SAC"
                                        : "No definido"
                                    }}
                                  </v-list-item-action-text>
                                </v-list-item-content>

                                <v-list-item-action>
                                  <v-list-item-action-text
                                    :class="active ? 'font-weight-bold' : ''"
                                  >
                                    Doc:{{
                                      item.moneda +
                                      " " +
                                      $formatoNumero(item.total_documento)
                                    }}
                                  </v-list-item-action-text>
                                  <v-list-item-action-text>
                                    Val:{{
                                      item.moneda +
                                      " " +
                                      $formatoNumero(item.total_valor)
                                    }}
                                  </v-list-item-action-text>

                                  <v-list-item-action-text>
                                    Ajuste:{{
                                      item.moneda +
                                      " " +
                                      $formatoNumero(item.total_ajuste)
                                    }}
                                  </v-list-item-action-text>
                                </v-list-item-action>
                              </template>
                            </v-list-item>
                          </template>
                        </v-virtual-scroll>
                      </v-list-item-group>
                    </v-list>
                  </v-card>
                </v-sheet>
              </v-card>
            </v-card>
          </v-flex>
        </v-layout>
      </v-dialog>

      <v-dialog
        v-model="dialogSigma"
        persistent
        :fullscreen="isMobile"
        max-width="500px"
        transition="dialog-bottom-transition"
      >
        <v-layout align-start v-resize="getDimensions">
          <v-flex>
            <v-card
              ref="form"
              id="lateral"
              :height="isMobile ? height : height - 100"
            >
              <v-system-bar color="white" lights-out>
                <v-spacer></v-spacer>
                <v-icon> fa-solid fa-store </v-icon>
                {{
                  "(" + clienteObject.codigo + ") " + clienteObject.descripcion
                }}
              </v-system-bar>
              <v-app-bar color="white" elevate-on-scroll flat>
                <div class="headline">Recibo N° {{ codigoRecibo }}</div>

                <v-spacer></v-spacer>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      @click="closeReciboDetalle"
                      color="icons"
                      v-bind="attrs"
                      v-on="on"
                      fab
                    >
                      <v-icon dark> close </v-icon>
                    </v-btn>
                  </template>
                  <span>Cerrar</span>
                </v-tooltip>
              </v-app-bar>

              <v-system-bar color="white" lights-out>
                <v-icon> fa-solid fa-calendar </v-icon>
                {{ $formatoFechaHoras(fechaRecibo) }}
              </v-system-bar>

              <v-sheet
                class="overflow-y-auto"
                :max-height="isMobile ? height - 60 : height - 60"
              >
                <v-container fluid>
                  <div>
                    <v-tooltip
                      bottom
                      v-if="
                        !(
                          foto_recibo === null ||
                          foto_recibo === undefined ||
                          foto_recibo === ''
                        )
                      "
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <img
                          v-img
                          :src="foto_recibo"
                          style="
                                    object-fit: fill;
                                    width: 70px;
                                    height: 70px;
                                    border-radius: 50%;
                                    border: solid 1px #ccc;
                                    }
                                  "
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>
                      <span>{{
                        foto_recibo === null ||
                        foto_recibo === undefined ||
                        foto_recibo === ""
                          ? "Cargar Imagen"
                          : "Ver Imagen"
                      }}</span>
                    </v-tooltip>
                  </div>

                  <v-list two-line>
                    <v-divider></v-divider>

                    <v-system-bar color="white">
                      <h3 class="primary--text">Documentos</h3>
                      <v-spacer></v-spacer>
                      Total {{ moneda + " " + $formatoNumero(total_documento) }}
                    </v-system-bar>

                    <v-divider></v-divider>
                    <v-list-item-group
                      v-model="selectedDocumentoElegido"
                      active-class="blue--text"
                    >
                      <template>
                        <v-list-item
                          v-for="item in dtDocumentoElegido"
                          :key="item.id"
                        >
                          <template v-slot:default="{ active }">
                            <v-list-item-content>
                              <v-list-item-title class="font-weight-bold"
                                >{{ item.codigo + " " + item.compro_tipo }}
                              </v-list-item-title>

                              <v-list-item-subtitle class="blue--text"
                                >{{
                                  item.compro_tipo === "C"
                                    ? "Nota de Crédito"
                                    : "Factura"
                                }}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle class="primary--text"
                                >{{ item.sucur_nombre }}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle
                                >FE: {{ $formatoFechaSpanish(item.fecha) }}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle
                                v-show="item.compro_tipo !== 'C'"
                                :class="
                                  estaVencido(item.venci_fecha)
                                    ? 'error--text'
                                    : 'success--text'
                                "
                                >FV:
                                {{ $formatoFechaSpanish(item.venci_fecha) }}
                              </v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-action>
                              <v-list-item-action-text
                                :class="active ? 'font-weight-bold' : ''"
                              >
                                Importe:
                                {{
                                  item.moneda +
                                  "" +
                                  $formatoNumero(item.importe)
                                }}
                              </v-list-item-action-text>

                              <v-list-item-action-text>
                                Total a Cancelar:
                                {{
                                  item.moneda +
                                  "" +
                                  $formatoNumero(item.subtotal)
                                }}
                              </v-list-item-action-text>
                            </v-list-item-action>
                          </template>
                        </v-list-item>
                      </template>
                    </v-list-item-group>
                  </v-list>

                  <v-list two-line>
                    <v-divider></v-divider>
                    <v-system-bar color="white">
                      <h3 class="primary--text">Valores</h3>
                      <v-spacer></v-spacer>
                      Total {{ moneda + " " + $formatoNumero(total_valor) }}
                    </v-system-bar>

                    <v-divider></v-divider>
                    <v-list-item-group
                      v-model="selectedValorElegido"
                      active-class="blue--text"
                    >
                      <template>
                        <v-list-item
                          v-for="item in dtValorElegido"
                          :key="item.id"
                        >
                          <template v-slot:default="{ active }">
                            <v-list-item-content>
                              <v-list-item-title class="font-weight-bold">
                                {{ item.descripcion_valor }}
                              </v-list-item-title>

                              <v-list-item-subtitle class="text--primary">
                                {{ $formatoFechaSpanish(item.fecha) }}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle class="text--primary">
                                {{ item.banco }}
                              </v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-action>
                              <v-list-item-action-text
                                :class="active ? 'font-weight-bold' : ''"
                              >
                                Importe: Bs. {{ $formatoNumero(item.monto) }}
                              </v-list-item-action-text>
                            </v-list-item-action>
                          </template>
                        </v-list-item>
                      </template>
                    </v-list-item-group>
                  </v-list>

                  <v-divider></v-divider>
                  <v-system-bar color="white">
                    <h3 class="primary--text">Ajuste</h3>
                    <v-spacer></v-spacer>
                    Total {{ moneda + " " + $formatoNumero(total_ajuste) }}
                  </v-system-bar>

                  <v-divider></v-divider>
                </v-container>
              </v-sheet>
            </v-card>
          </v-flex>
        </v-layout>
      </v-dialog>

      <v-dialog
        v-model="dialogBeta"
        persistent
        :fullscreen="isMobile"
        max-width="500px"
        transition="dialog-bottom-transition"
      >
        <v-layout align-start v-resize="getDimensions">
          <v-flex>
            <v-card
              ref="form"
              id="lateral"
              :height="isMobile ? height : height - 100"
            >
              <v-system-bar :color="clienteObject.color" dark>
                <v-icon> fa-solid fa-store </v-icon>
                {{
                  "(" +
                  clienteObject.codigo +
                  ") " +
                  clienteObject.descripcion +
                  " - " +
                  clienteObject.forma_pago
                }}
              </v-system-bar>

              <v-system-bar color="white" lights-out>
                <v-icon :color="clienteObject.color">
                  fa-solid fa-user-tie
                </v-icon>
                {{ "(" + talonarioRecibo + ") " + nombreUsuario }}
                <v-spacer></v-spacer>
              </v-system-bar>

              <v-system-bar color="white" lights-out>
                <v-icon :color="clienteObject.color">
                  fa-solid fa-calendar
                </v-icon>
                {{ $formatoFechaSpanish(fechaRecibo) }}
              </v-system-bar>
              <v-system-bar v-if="metodoPagoCambiado" color="error" dark>
                <v-icon> fa-solid fa-money-bill-1-wave </v-icon>
                Método de pago diferente al acordado
              </v-system-bar>

              <v-app-bar color="white" elevate-on-scroll flat>
                <div class="headline">Recibo N° {{ codigoRecibo }}</div>

                <v-spacer></v-spacer>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      @click="closeRecibo"
                      color="icons"
                      v-bind="attrs"
                      v-on="on"
                      fab
                    >
                      <v-icon dark> close </v-icon>
                    </v-btn>
                  </template>
                  <span>Cancelar</span>
                </v-tooltip>
              </v-app-bar>
              <v-system-bar color="error" dark v-if="errorLocation !== null">
                <v-icon> fa-solid fa-location-dot </v-icon>
                {{ errorLocation }}
              </v-system-bar>

              <v-sheet
                class="overflow-y-auto"
                :max-height="isMobile ? height - 60 : height - 60"
              >
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field
                        outlined
                        color="icons"
                        dense
                        reverse
                        type="text"
                        ref="documentoRecibo"
                        v-model="documentoRecibo"
                        :readonly="true"
                        @click="showDocumento"
                        @change="calcularBalance"
                        :rules="[$rules.requerido]"
                        :error-messages="errorMessagesRecibo"
                        label="Documentos"
                      >
                        <template v-slot:append>
                          <v-icon
                            :color="clienteObject.color"
                            @click="showDocumento"
                          >
                            fa-solid fa-receipt
                          </v-icon>
                        </template>
                      </v-text-field>
                      <v-text-field
                        outlined
                        color="icons"
                        dense
                        reverse
                        type="text"
                        ref="valorRecibo"
                        v-model="valorRecibo"
                        :readonly="true"
                        @click="showValores"
                        @change="calcularBalance"
                        :rules="[$rules.requerido]"
                        :error-messages="errorMessagesRecibo"
                        label="Medios de pago"
                      >
                        <template v-slot:append>
                          <v-icon
                            :color="clienteObject.color"
                            @click="showValores"
                          >
                            fa-solid fa-money-bills
                          </v-icon>
                        </template>
                      </v-text-field>

                      <v-text-field
                        outlined
                        type="tel"
                        color="icons"
                        dense
                        reverse
                        v-mask="'#.##'"
                        ref="ajusteRecibo"
                        @change="calcularBalance"
                        v-model="ajusteRecibo"
                        :readonly="false"
                        :rules="[$rules.numero, $rules.maximoAjuste]"
                        :error-messages="errorMessagesRecibo"
                        label="Ajuste"
                      >
                        <template v-slot:append>
                          <v-btn
                            icon
                            x-small
                            :color="tipoAjusteRecibo ? 'success' : 'error'"
                            @click="tipoAjusteRecibo = !tipoAjusteRecibo"
                            dark
                          >
                            <v-icon>{{
                              !tipoAjusteRecibo
                                ? "fa-solid fa-minus"
                                : "fa-solid fa-plus"
                            }}</v-icon>
                          </v-btn>
                        </template>
                      </v-text-field>

                      <v-text-field
                        outlined
                        color="icons"
                        dense
                        reverse
                        type="text"
                        ref="balanceRecibo"
                        v-model="balanceRecibo"
                        :readonly="true"
                        :rules="[$rules.requerido]"
                        :error-messages="errorMessagesRecibo"
                        label="Balance"
                      ></v-text-field>
                    </v-col>
                    <v-list>
                      <v-list-item-group>
                        <v-list-item color="white"> </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-row>
                </v-container>
              </v-sheet>

              <v-btn
                v-if="errorLocation === null"
                color="success"
                fab
                large
                dark
                class="bottom-button"
                @click="mostrarConfirmacion"
              >
                <v-icon>done</v-icon>
              </v-btn>
              <v-btn
                v-else
                color="error"
                fab
                large
                dark
                class="bottom-button"
                @click="getLocation()"
              >
                <v-icon>refresh</v-icon>
              </v-btn>
            </v-card>
          </v-flex>
        </v-layout>
      </v-dialog>

      <v-dialog
        v-model="dialogTau"
        persistent
        :fullscreen="isMobile"
        max-width="500px"
        transition="dialog-bottom-transition"
      >
        <v-layout align-start v-resize="getDimensions">
          <v-flex>
            <v-card
              ref="form"
              id="lateral"
              :height="isMobile ? height : height - 100"
            >
              <v-app-bar color="white" elevate-on-scroll flat>
                <div>
                  {{
                    "(" +
                    clienteObject.codigo +
                    ") " +
                    clienteObject.descripcion
                  }}
                </div>

                <v-spacer></v-spacer>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      @click="closeActualizarCliente"
                      color="icons"
                      v-bind="attrs"
                      v-on="on"
                      fab
                    >
                      <v-icon dark> close </v-icon>
                    </v-btn>
                  </template>
                  <span>Cancelar</span>
                </v-tooltip>
              </v-app-bar>
              <v-system-bar color="error" dark v-if="errorLocation !== null">
                <v-icon> fa-solid fa-location-dot </v-icon>
                {{ errorLocation }}
              </v-system-bar>

              <v-sheet
                class="overflow-y-auto"
                :max-height="isMobile ? height - 60 : height - 60"
              >
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field
                        outlined
                        color="icons"
                        dense
                        type="text"
                        v-model="clienteObject.nombre_contacto"
                        :rules="[$rules.requerido]"
                        :error-messages="errorMessagesRecibo"
                        label="Nombre Contacto"
                      >
                      </v-text-field>
                      <v-text-field
                        outlined
                        color="icons"
                        dense
                        type="tel"
                        v-mask="'########'"
                        v-model="clienteObject.telefono_contacto"
                        :rules="[$rules.requerido]"
                        :error-messages="errorMessagesRecibo"
                        label="Teléfono Contacto"
                      >
                      </v-text-field>
                      <v-text-field
                        outlined
                        color="icons"
                        dense
                        type="text"
                        v-model="clienteObject.direccion"
                        :rules="[$rules.requerido]"
                        :error-messages="errorMessagesRecibo"
                        label="Dirección"
                      >
                      </v-text-field>

                      <mapa-con-marcador
                        title="Seleccione la Ubicación"
                        :isMobile="isMobile"
                        :height="630"
                        @locationSaved="handleLocationSaved"
                      />
                      <div style="height: 15px"></div>

                      <location-map
                        :title="
                          '(' +
                          clienteObject.codigo +
                          ') ' +
                          clienteObject.descripcion
                        "
                        :location="{
                          lat: clienteObject.latitud,
                          lng: clienteObject.longitud,
                        }"
                        :icon="false"
                        :isMobile="isMobile"
                        :height="height - 200"
                      ></location-map>
                    </v-col>
                    <v-list>
                      <v-list-item-group>
                        <v-list-item color="white"> </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-row>
                </v-container>
              </v-sheet>

              <v-btn
                color="success"
                fab
                large
                dark
                :loading="loadButton"
                class="bottom-button"
                @click="guardarCliente"
              >
                <v-icon>done</v-icon>
              </v-btn>
            </v-card>
          </v-flex>
        </v-layout>
      </v-dialog>

      <v-dialog
        v-model="dialogGamma"
        :fullscreen="isMobile"
        max-width="500px"
        persistent
      >
        <v-layout align-start v-resize="getDimensions">
          <v-flex>
            <v-card ref="form" :height="isMobile ? height : height - 95">
              <v-system-bar color="white" lights-out>
                <v-spacer></v-spacer>
                <v-icon> fa-solid fa-store </v-icon>
                {{
                  "(" + clienteObject.codigo + ") " + clienteObject.descripcion
                }}
              </v-system-bar>
              <v-app-bar color="white" elevate-on-scroll flat>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      @click="closeDocumentoElegido"
                      color="icons"
                      v-bind="attrs"
                      v-on="on"
                      fab
                    >
                      <v-icon dark> fa-solid fa-chevron-left </v-icon>
                    </v-btn>
                  </template>
                  <span>Volver</span>
                </v-tooltip>
                <div v-if="!showSearchDocumentoElegido">
                  <span class="headline">Documentos</span>
                </div>

                <v-spacer></v-spacer>
                <div v-if="showSearchDocumentoElegido">
                  <v-text-field
                    color="icons"
                    outlined
                    dense
                    v-model="searchDocumentoElegido"
                    @click:append="showFinderDocumentoElegido"
                    label="Búsqueda de Documentos"
                    hide-details
                    append-icon="fa-solid fa-xmark"
                    prepend-icon="search"
                    hint="Pulse el botón a la izquierda para cambiar el tipo de búsqueda"
                  ></v-text-field>
                </div>
                <div v-else>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        large
                        @click="
                          showSearchDocumentoElegido =
                            !showSearchDocumentoElegido
                        "
                        color="icons"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark>
                          {{
                            showSearchDocumentoElegido ? "search_off" : "search"
                          }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{
                      showSearchDocumentoElegido
                        ? "Ocultar filtros de búsqueda"
                        : "Mostrar filtros de búsqueda"
                    }}</span>
                  </v-tooltip>
                </div>
              </v-app-bar>

              <v-card :height="isMobile ? height - 87 : height - 185">
                <v-sheet
                  class="overflow-y-auto"
                  :max-height="isMobile ? height - 90 : height - 185"
                >
                  <v-card class="mx-auto" :max-width="width">
                    <v-system-bar color="success">
                      <div class="white--text text-center font-weight-bold">
                        {{ detailDocumentoElegido }}
                      </div>
                    </v-system-bar>

                    <v-divider></v-divider>
                    <v-list two-line>
                      <v-list-item-group
                        v-model="selectedDocumentoElegido"
                        active-class="blue--text"
                      >
                        <template>
                          <v-list-item
                            v-for="(item, index) in filtrarDtDocumentoElegido"
                            :key="item.id"
                          >
                            <template v-slot:default="{ active }">
                              <v-list-item-content>
                                <v-list-item-title class="font-weight-bold"
                                  >{{ item.codigo + " " + item.compro_tipo }}
                                </v-list-item-title>
                                <v-list-item-subtitle class="blue--text"
                                  >{{
                                    item.compro_tipo === "C"
                                      ? "Nota de Crédito"
                                      : "Factura"
                                  }}
                                </v-list-item-subtitle>

                                <v-list-item-subtitle class="primary--text"
                                  >{{ item.sucur_nombre }}
                                </v-list-item-subtitle>

                                <v-list-item-subtitle
                                  >FE: {{ $formatoFechaSpanish(item.fecha) }}
                                </v-list-item-subtitle>
                                <v-list-item-subtitle
                                  v-show="item.compro_tipo !== 'C'"
                                  :class="
                                    estaVencido(item.venci_fecha)
                                      ? 'error--text'
                                      : 'success--text'
                                  "
                                  >FV:
                                  {{ $formatoFechaSpanish(item.venci_fecha) }}
                                </v-list-item-subtitle>

                                <v-list-item-subtitle class="caption">
                                  {{ item.descripcion }}
                                </v-list-item-subtitle>
                                <v-list-item-subtitle v-if="active">
                                  .
                                </v-list-item-subtitle>
                              </v-list-item-content>

                              <v-list-item-action>
                                <v-list-item-action-text
                                  :class="'font-weight-bold'"
                                >
                                  Importe:
                                  {{
                                    item.moneda +
                                    "" +
                                    $formatoNumero(item.importe)
                                  }}
                                </v-list-item-action-text>
                                <v-list-item-action-text
                                  :class="'font-weight-bold'"
                                >
                                  Saldo:
                                  {{
                                    item.moneda +
                                    "" +
                                    $formatoNumero(item.saldo)
                                  }}
                                </v-list-item-action-text>

                                <v-list-item-action-text
                                  :class="'font-weight-bold'"
                                >
                                  Total a Cancelar:
                                  {{
                                    item.moneda +
                                    "" +
                                    $formatoNumero(item.subtotal)
                                  }}
                                </v-list-item-action-text>
                                <v-list-item-action-text v-if="active"
                                  ><v-btn
                                    v-if="rol !== 'REP'"
                                    class="mx-2"
                                    icon
                                    dark
                                    x-small
                                    color="primary"
                                    @click="
                                      editDocumento(
                                        active,
                                        item,
                                        index,
                                        'Elegido'
                                      )
                                    "
                                  >
                                    <v-icon dark>
                                      fa-solid fa-pen-to-square
                                    </v-icon>
                                  </v-btn>
                                  <v-btn
                                    class="mx-2"
                                    icon
                                    dark
                                    x-small
                                    color="error"
                                    @click="deleteDocumentoElegido(item)"
                                  >
                                    <v-icon dark> fa-solid fa-trash </v-icon>
                                  </v-btn></v-list-item-action-text
                                >
                              </v-list-item-action>
                            </template>
                          </v-list-item>
                        </template>
                      </v-list-item-group>
                      <v-list-item-group>
                        <v-list-item color="white"> </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-card>
                </v-sheet>
              </v-card>

              <v-btn
                color="success"
                fab
                large
                @click="addDocumento"
                dark
                class="bottom-button"
              >
                <v-icon>add</v-icon>
              </v-btn>
            </v-card>
          </v-flex>
        </v-layout>
      </v-dialog>

      <v-dialog
        v-model="dialogDelta"
        :max-width="isMobile ? '100%' : '500px'"
        :fullscreen="isMobile ? true : false"
        persistent
      >
        <v-layout align-start v-resize="getDimensions">
          <v-flex>
            <v-card ref="form" :height="isMobile ? height : height - 100">
              <v-system-bar color="white" lights-out>
                <v-spacer></v-spacer>
                <v-icon> fa-solid fa-store </v-icon>
                {{
                  "(" + clienteObject.codigo + ") " + clienteObject.descripcion
                }}
              </v-system-bar>

              <v-app-bar color="white" elevate-on-scroll flat>
                <div v-if="!showSearchDocumentoLista">
                  <span>Seleccione:</span>
                </div>

                <v-spacer></v-spacer>
                <div v-if="showSearchDocumentoLista">
                  <v-text-field
                    color="icons"
                    outlined
                    dense
                    v-model="searchDocumentoLista"
                    @click:append="showFinderDocumentoLista"
                    label="Búsqueda de Documentos"
                    hide-details
                    append-icon="fa-solid fa-xmark"
                    prepend-icon="search"
                    hint="Pulse el botón a la izquierda para cambiar el tipo de búsqueda"
                  ></v-text-field>
                </div>
                <div v-else>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        large
                        @click="
                          selectedDocLista.length == 0
                            ? selectAllDocumentoLista()
                            : selectNoneDocumentoLista()
                        "
                        color="icons"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark>
                          {{
                            selectedDocLista.length == 0
                              ? "fa-solid fa-list-check"
                              : "fa-solid fa-list"
                          }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{
                      selectedDocLista.length == 0
                        ? "Seleccionar todos"
                        : "Quitar selección"
                    }}</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        large
                        @click="
                          showSearchDocumentoLista = !showSearchDocumentoLista
                        "
                        color="icons"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark>
                          {{
                            showSearchDocumentoLista ? "search_off" : "search"
                          }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{
                      showSearchDocumentoLista
                        ? "Ocultar filtros de búsqueda"
                        : "Mostrar filtros de búsqueda"
                    }}</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        @click="showFiltroDocumentoLista"
                        :color="flagFiltroDoc ? 'primary' : 'icons'"
                        v-bind="attrs"
                        v-on="on"
                        fab
                      >
                        <v-icon dark>
                          {{
                            flagFiltroDoc
                              ? "fa-solid fa-filter"
                              : "filter_list_off"
                          }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Mostrar Filtros</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        @click="closeDocumentoLista"
                        color="icons"
                        v-bind="attrs"
                        v-on="on"
                        fab
                      >
                        <v-icon dark> close </v-icon>
                      </v-btn>
                    </template>
                    <span>Cancelar</span>
                  </v-tooltip>
                </div>
              </v-app-bar>

              <v-progress-linear
                :active="loadGenerico"
                :indeterminate="loadGenerico"
                absolute
                top
                height="7"
                color="primary"
              ></v-progress-linear>
              <v-card :height="isMobile ? height - 80 : height - 190">
                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                    dense
                    outlined
                    ref="formFiltroDocumentoDireccion"
                    v-model="formFiltroDocumentoDireccion"
                    :items="itemsFormFiltroDocumentoDireccion"
                    :rules="[]"
                    @change="listarDocumentos"
                    :error-messages="errorMessagesValor"
                    item-text="descripcion"
                    item-value="id"
                    label="Direcciones"
                    required
                    hide-details
                  >
                  </v-autocomplete>
                </v-col>

                <v-sheet
                  class="overflow-y-auto"
                  :max-height="isMobile ? height - 170 : height - 260"
                >
                  <v-card class="mx-auto" :max-width="width">
                    <v-list two-line>
                      <v-list-item-group
                        v-model="selectedDocumentoLista"
                        active-class="blue--text"
                        multiple
                      >
                        <template>
                          <v-list-item
                            v-for="(item, index) in filtrarDtDocumentoLista"
                            :key="item.id"
                          >
                            <template v-slot:default="{ active }">
                              <v-list-item-content
                                @click="
                                  showDetailDocumentoLista(active, item, index)
                                "
                              >
                                <v-list-item-title class="font-weight-bold"
                                  >{{
                                    item.codigo +
                                    (item.contra_entrega &&
                                    item.compro_tipo === "F"
                                      ? " Contra Entrega"
                                      : "")
                                  }}
                                </v-list-item-title>
                                <v-list-item-subtitle class="blue--text"
                                  >{{
                                    item.compro_tipo === "C"
                                      ? "Nota de Crédito"
                                      : "Factura"
                                  }}
                                </v-list-item-subtitle>

                                <v-list-item-subtitle class="primary--text"
                                  >{{ item.sucur_nombre }}
                                </v-list-item-subtitle>
                                <v-list-item-subtitle
                                  >FE: {{ $formatoFechaSpanish(item.fecha) }}
                                </v-list-item-subtitle>
                                <v-list-item-subtitle
                                  v-show="item.compro_tipo !== 'C'"
                                  :class="
                                    estaVencido(item.venci_fecha)
                                      ? 'error--text'
                                      : 'success--text'
                                  "
                                  >FV:
                                  {{ $formatoFechaSpanish(item.venci_fecha) }}
                                </v-list-item-subtitle>

                                <v-list-item-subtitle v-if="active">
                                  .
                                </v-list-item-subtitle>
                              </v-list-item-content>

                              <v-list-item-action
                                v-if="!active"
                                @click="
                                  showDetailDocumentoLista(active, item, index)
                                "
                              >
                                <v-list-item-action-text
                                  :class="'font-weight-bold'"
                                >
                                  Importe:
                                  {{
                                    item.moneda +
                                    "" +
                                    $formatoNumero(item.importe)
                                  }}
                                </v-list-item-action-text>
                                <v-list-item-action-text
                                  :class="'font-weight-bold'"
                                >
                                  Saldo:
                                  {{
                                    item.moneda +
                                    "" +
                                    $formatoNumero(item.saldo)
                                  }}
                                </v-list-item-action-text>

                                <v-list-item-action-text
                                  :class="'font-weight-bold'"
                                >
                                  Total a Cancelar:
                                  {{
                                    item.moneda +
                                    "" +
                                    $formatoNumero(item.subtotal)
                                  }}
                                </v-list-item-action-text>
                              </v-list-item-action>

                              <v-list-item-action
                                v-else
                                @click="
                                  showDetailDocumentoLista(active, item, index)
                                "
                              >
                                <v-list-item-action-text
                                  :class="'font-weight-bold'"
                                >
                                  Importe:
                                  {{
                                    item.moneda +
                                    "" +
                                    $formatoNumero(item.importe)
                                  }}
                                </v-list-item-action-text>
                                <v-list-item-action-text
                                  :class="'font-weight-bold'"
                                >
                                  Saldo
                                  {{
                                    item.moneda +
                                    "" +
                                    $formatoNumero(item.saldo)
                                  }}
                                </v-list-item-action-text>

                                <v-list-item-action-text
                                  :class="'font-weight-bold'"
                                >
                                  Total a Cancelar:
                                  {{
                                    item.moneda +
                                    "" +
                                    $formatoNumero(item.subtotal)
                                  }}
                                </v-list-item-action-text>
                                <v-list-item-action-text
                                  :class="'font-weight-bold'"
                                  v-if="rol !== 'REP'"
                                >
                                  <v-btn
                                    class="mx-2"
                                    icon
                                    dark
                                    x-small
                                    color="primary"
                                    @click="
                                      editDocumento(
                                        active,
                                        item,
                                        index,
                                        'Lista'
                                      )
                                    "
                                  >
                                    <v-icon dark>
                                      fa-solid fa-pen-to-square
                                    </v-icon>
                                  </v-btn></v-list-item-action-text
                                >
                              </v-list-item-action>
                            </template>
                          </v-list-item>
                        </template>
                      </v-list-item-group>
                      <v-list-item-group>
                        <v-list-item color="white"> </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-card>
                </v-sheet>
              </v-card>

              <v-btn
                class="bottom-button"
                color="success"
                :disabled="cantidadDocumentoLista == 0"
                large
                @click="saveDocumentoLista()"
              >
                {{ detailDocumentoLista }}
              </v-btn>
            </v-card>
          </v-flex>
        </v-layout>
      </v-dialog>

      <v-dialog
        v-model="dialogNu"
        :fullscreen="false"
        :max-width="isMobile ? '100%' : '500px'"
        persistent
      >
        <v-layout align-start v-resize="getDimensions">
          <v-flex>
            <v-card ref="form" :height="isMobile ? height - 75 : height - 100">
              <v-app-bar color="white" elevate-on-scroll flat>
                <div v-if="!showSearchValorLista">
                  <span style="display: none">Seleccione:</span>
                </div>

                <v-spacer></v-spacer>
                <div v-if="showSearchValorLista">
                  <v-text-field
                    color="icons"
                    outlined
                    dense
                    v-model="searchValorLista"
                    @click:append="showFinderValorLista"
                    label="Búsqueda de Valores"
                    hide-details
                    append-icon="fa-solid fa-xmark"
                    prepend-icon="search"
                    hint="Pulse el botón a la izquierda para cambiar el tipo de búsqueda"
                  ></v-text-field>
                </div>
                <div v-else>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        large
                        @click="showSearchValorLista = !showSearchValorLista"
                        color="icons"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark>
                          {{ showSearchValorLista ? "search_off" : "search" }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{
                      showSearchValorLista
                        ? "Ocultar filtros de búsqueda"
                        : "Mostrar filtros de búsqueda"
                    }}</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        @click="showFiltroValorLista"
                        :color="flagFiltroVal ? 'primary' : 'icons'"
                        v-bind="attrs"
                        v-on="on"
                        fab
                      >
                        <v-icon dark>
                          {{
                            flagFiltroVal
                              ? "fa-solid fa-filter"
                              : "filter_list_off"
                          }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Mostrar Filtros</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        @click="closeValorLista"
                        color="icons"
                        v-bind="attrs"
                        v-on="on"
                        fab
                      >
                        <v-icon dark> close </v-icon>
                      </v-btn>
                    </template>
                    <span>Cancelar</span>
                  </v-tooltip>
                </div>
              </v-app-bar>

              <v-card :height="isMobile ? height - 130 : height - 170">
                <v-sheet
                  class="overflow-y-auto"
                  :max-height="isMobile ? height - 130 : height - 170"
                >
                  <v-card class="mx-auto" :max-width="width">
                    <v-list two-line>
                      <v-list-item-group
                        v-model="selectedValorLista"
                        active-class="blue--text"
                        multiple
                      >
                        <template>
                          <v-list-item
                            v-for="(item, index) in filtrarDtValorLista"
                            :key="item.id"
                          >
                            <template v-slot:default="{ active }">
                              <v-list-item-content
                                @click="
                                  item.estado == 'A'
                                    ? showDetailValorLista(active, item, index)
                                    : (item.estado = item.estado)
                                "
                              >
                                <v-list-item-title class="font-weight-bold">
                                  {{ item.descripcion_tipo_valor }}
                                </v-list-item-title>

                                <v-list-item-subtitle class="text--primary">
                                  {{ $formatoFechaSpanish(item.fecha) }}
                                </v-list-item-subtitle>

                                <v-list-item-subtitle class="text--primary">
                                  {{ item.banco }}
                                </v-list-item-subtitle>

                                <v-list-item-subtitle v-if="active">
                                  .
                                </v-list-item-subtitle>
                              </v-list-item-content>

                              <v-list-item-action
                                v-if="active && item.estado == 'A'"
                                @click="
                                  item.estado == 'A'
                                    ? showDetailValorLista(active, item, index)
                                    : (item.estado = item.estado)
                                "
                              >
                                <v-list-item-action-text
                                  :class="active ? 'font-weight-bold' : ''"
                                >
                                  Importe:
                                  {{
                                    item.moneda +
                                    "" +
                                    $formatoNumero(item.monto)
                                  }}
                                </v-list-item-action-text>

                                <v-list-item-action-text>
                                  <v-btn
                                    class="mx-2"
                                    icon
                                    dark
                                    x-small
                                    color="red"
                                    v-if="
                                      !item.descripcion_tipo_valor.startsWith(
                                        'Transferencia'
                                      )
                                    "
                                    @click="
                                      editValorLista(
                                        active,
                                        item,
                                        index,
                                        'Lista'
                                      )
                                    "
                                  >
                                    <v-icon dark>
                                      fa-solid fa-pen-to-square
                                    </v-icon>
                                  </v-btn></v-list-item-action-text
                                >
                              </v-list-item-action>

                              <v-list-item-action
                                v-else
                                @click="
                                  item.estado == 'A'
                                    ? showDetailValorLista(active, item, index)
                                    : (item.estado = item.estado)
                                "
                              >
                                <v-list-item-action-text
                                  :class="active ? 'font-weight-bold' : ''"
                                >
                                  Importe:
                                  {{
                                    item.moneda +
                                    "" +
                                    $formatoNumero(item.monto)
                                  }}
                                </v-list-item-action-text>

                                <v-list-item-action-text
                                  :class="
                                    item.estado == 'P'
                                      ? 'warning--text'
                                      : item.estado == 'A'
                                      ? 'success--text'
                                      : 'error--text'
                                  "
                                >
                                  Estado:
                                  {{
                                    item.estado == "P"
                                      ? "Pendiente"
                                      : item.estado == "A"
                                      ? "Aprobado"
                                      : "Rechazado"
                                  }}
                                </v-list-item-action-text>
                              </v-list-item-action>
                            </template>
                          </v-list-item>
                        </template>
                      </v-list-item-group>
                      <v-list-item-group>
                        <v-list-item color="white"> </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-card>
                </v-sheet>
              </v-card>

              <v-btn
                class="bottom-button"
                color="success"
                :disabled="cantidadValorLista == 0"
                large
                @click="saveValorLista()"
              >
                {{ detailValorLista }}
              </v-btn>
            </v-card>
          </v-flex>
        </v-layout>
      </v-dialog>

      <v-dialog
        v-model="dialogIota"
        :fullscreen="isMobile ? true : false"
        persistent
        :max-width="isMobile ? '100%' : '500px'"
        transition="dialog-bottom-transition"
      >
        <v-layout align-start v-resize="getDimensions">
          <v-flex>
            <v-card ref="form" :height="isMobile ? height : height - 90">
              <v-system-bar color="white" lights-out>
                <v-spacer></v-spacer>
                <v-icon> fa-solid fa-store </v-icon>
                {{
                  "(" + clienteObject.codigo + ") " + clienteObject.descripcion
                }}
              </v-system-bar>
              <v-app-bar color="white" elevate-on-scroll flat>
                <span class="headline">Detalles Documento</span>

                <v-spacer></v-spacer>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      @click="closeDocumentoListaDetalle()"
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      fab
                    >
                      <v-icon dark> close </v-icon>
                    </v-btn>
                  </template>
                  <span>Cancelar</span>
                </v-tooltip>
              </v-app-bar>

              <v-sheet
                class="overflow-y-auto"
                :max-height="isMobile ? height - 60 : height - 60"
              >
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field
                        outlined
                        color="icons"
                        dense
                        type="text"
                        ref="formDocCodigo"
                        v-model="formDocCodigo"
                        :readonly="false"
                        :rules="[$rules.requerido, $rules.max50, $rules.min2]"
                        :error-messages="errorMessagesForm"
                        label="Código de Documento"
                        required
                      ></v-text-field>
                      <v-text-field
                        outlined
                        color="icons"
                        dense
                        type="text"
                        ref="formDocDescripcion"
                        v-model="formDocDescripcion"
                        :readonly="false"
                        :rules="[]"
                        :error-messages="errorMessagesForm"
                        label="Detalle de Documento"
                      ></v-text-field>
                      <v-text-field
                        outlined
                        reverse
                        color="icons"
                        dense
                        type="text"
                        ref="formDocImporte"
                        v-model="formDocImporte"
                        :readonly="true"
                        :rules="[]"
                        :error-messages="errorMessagesForm"
                        label="Importe"
                      ></v-text-field>
                      <v-text-field
                        outlined
                        reverse
                        color="icons"
                        dense
                        type="text"
                        ref="formDocSaldo"
                        v-model="formDocSaldo"
                        :readonly="true"
                        :rules="[]"
                        :error-messages="errorMessagesForm"
                        label="Saldo"
                      ></v-text-field>
                      <v-text-field
                        outlined
                        reverse
                        color="icons"
                        dense
                        ref="formDocSubtotal"
                        v-model="formDocSubtotal"
                        type="tel"
                        @change="
                          formDocSubtotal = $formatoNumero(formDocSubtotal)
                        "
                        :readonly="false"
                        :rules="[]"
                        :error-messages="errorMessagesForm"
                        label="Total a Cancelar"
                        @click:append="formDocSubtotal = ''"
                        append-icon="fa-solid fa-xmark"
                      ></v-text-field>
                    </v-col>
                    <v-list>
                      <v-list-item-group>
                        <v-list-item color="white"> </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-row>
                </v-container>
              </v-sheet>

              <v-btn
                color="success"
                fab
                large
                dark
                class="bottom-button"
                @click="saveEditDocumentoLista"
              >
                <v-icon>done</v-icon>
              </v-btn>
            </v-card>
          </v-flex>
        </v-layout>
      </v-dialog>

      <v-dialog
        v-model="dialogKappa"
        :fullscreen="isMobile"
        :max-width="isMobile ? '100%' : '500px'"
        persistent
        :retain-focus="false"
      >
        <v-layout align-start v-resize="getDimensions">
          <v-flex>
            <v-card ref="form" :height="isMobile ? height : height - 90">
              <v-system-bar color="white" lights-out>
                <v-spacer></v-spacer>
                <v-icon> fa-solid fa-store </v-icon>
                {{
                  "(" + clienteObject.codigo + ") " + clienteObject.descripcion
                }}
              </v-system-bar>
              <v-app-bar color="white" elevate-on-scroll flat>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      @click="closeValorElegido"
                      color="icons"
                      v-bind="attrs"
                      v-on="on"
                      fab
                    >
                      <v-icon dark> fa-solid fa-chevron-left </v-icon>
                    </v-btn>
                  </template>
                  <span>Cancelar</span>
                </v-tooltip>
                <div v-if="!showSearchValorElegido">
                  <span class="headline">Medios de Pago</span>
                </div>

                <v-spacer></v-spacer>
                <div v-if="showSearchValorElegido">
                  <v-text-field
                    color="icons"
                    outlined
                    dense
                    v-model="searchValorElegido"
                    @click:append="showFinderValorElegido"
                    label="Búsqueda de Medios de pago"
                    hide-details
                    append-icon="fa-solid fa-xmark"
                    prepend-icon="search"
                    hint="Pulse el botón a la izquierda para cambiar el tipo de búsqueda"
                  ></v-text-field>
                </div>
                <div v-else>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        large
                        @click="
                          showSearchValorElegido = !showSearchValorElegido
                        "
                        color="icons"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark>
                          {{ showSearchValorElegido ? "search_off" : "search" }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{
                      showSearchValorElegido
                        ? "Ocultar filtros de búsqueda"
                        : "Mostrar filtros de búsqueda"
                    }}</span>
                  </v-tooltip>
                </div>
              </v-app-bar>

              <v-card :height="isMobile ? height - 87 : height - 185">
                <v-sheet
                  class="overflow-y-auto"
                  :max-height="isMobile ? height - 90 : height - 185"
                >
                  <v-card class="mx-auto" :max-width="width">
                    <v-system-bar color="success">
                      <div class="white--text text-center font-weight-bold">
                        {{ detailValorElegido }}
                      </div>
                    </v-system-bar>

                    <v-divider></v-divider>
                    <v-list two-line>
                      <v-list-item-group
                        v-model="selectedValorElegido"
                        active-class="blue--text"
                      >
                        <template>
                          <v-list-item
                            v-for="(item, index) in filtrarDtValorElegido"
                            :key="item.id"
                          >
                            <template v-slot:default="{ active }">
                              <v-list-item-content>
                                <v-list-item-title class="font-weight-bold">
                                  {{ item.descripcion_tipo_valor }}
                                </v-list-item-title>

                                <v-list-item-subtitle class="text--primary">
                                  {{ $formatoFechaSpanish(item.fecha) }}
                                </v-list-item-subtitle>
                                <v-list-item-subtitle class="text--primary">
                                  {{ item.banco }}
                                </v-list-item-subtitle>

                                <v-list-item-subtitle v-if="active">
                                  .
                                </v-list-item-subtitle>
                              </v-list-item-content>

                              <v-list-item-action>
                                <v-list-item-action-text
                                  :class="active ? 'font-weight-bold' : ''"
                                >
                                  Importe: Bs. {{ $formatoNumero(item.monto) }}
                                </v-list-item-action-text>
                                <v-list-item-action-text v-if="active"
                                  ><v-btn
                                    v-if="item.id_tipo_valor != 1"
                                    class="mx-2"
                                    icon
                                    dark
                                    x-small
                                    color="primary"
                                    @click="editValor(item, index)"
                                  >
                                    <v-icon dark>
                                      fa-solid fa-pen-to-square
                                    </v-icon>
                                  </v-btn>
                                  <v-btn
                                    class="mx-2"
                                    icon
                                    dark
                                    x-small
                                    color="error"
                                    @click="deleteValorElegido(item)"
                                  >
                                    <v-icon dark> fa-solid fa-trash </v-icon>
                                  </v-btn></v-list-item-action-text
                                >
                              </v-list-item-action>
                            </template>
                          </v-list-item>
                        </template>
                      </v-list-item-group>
                      <v-list-item-group>
                        <v-list-item color="white"> </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-card>
                </v-sheet>
              </v-card>

              <v-menu top :close-on-click="true" :offset-y="true">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="success"
                    fab
                    large
                    dark
                    class="bottom-button"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>add</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item>
                    <v-list-item-title
                      :class="
                        clienteObject.forma_pago === 'No Electronico'
                          ? 'primary--text font-weight-black'
                          : ''
                      "
                      @click="addValor('E')"
                      >Efectivo y Cheque</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title
                      :class="
                        clienteObject.forma_pago === 'Electronico'
                          ? 'primary--text font-weight-black'
                          : ''
                      "
                      @click="showListaValores()"
                      >Transferencia</v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-card>
          </v-flex>
        </v-layout>
      </v-dialog>

      <v-dialog
        v-model="dialogLambda"
        persistent
        :retain-focus="false"
        :fullscreen="isMobile"
        max-width="500px"
        transition="dialog-bottom-transition"
      >
        <v-layout align-start v-resize="getDimensions">
          <v-flex>
            <v-card
              ref="form"
              id="lateral"
              :height="isMobile ? height : height - 100"
            >
              <v-system-bar color="white" lights-out>
                <v-spacer></v-spacer>
                <v-icon> fa-solid fa-store </v-icon>
                {{
                  "(" + clienteObject.codigo + ") " + clienteObject.descripcion
                }}
              </v-system-bar>
              <v-app-bar color="white" elevate-on-scroll flat>
                <span class="headline">Medio de Pago</span>

                <v-spacer></v-spacer>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      @click="closeValorDetalle"
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      fab
                    >
                      <v-icon dark> close </v-icon>
                    </v-btn>
                  </template>
                  <span>Cancelar</span>
                </v-tooltip>
              </v-app-bar>

              <v-sheet
                class="overflow-y-auto"
                :max-height="isMobile ? height - 60 : height - 60"
              >
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-autocomplete
                        dense
                        outlined
                        ref="formValorTipo"
                        v-model="formValorTipo"
                        :items="itemsFormValorTipo"
                        :rules="[$rules.requerido]"
                        :error-messages="errorMessagesValor"
                        item-text="descripcion"
                        item-value="id"
                        @change="mostrarDetallesTipoValor"
                        label="Tipo de medio de pago"
                        required
                        hide-details
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="6" sm="6" md="6">
                      <v-autocomplete
                        dense
                        outlined
                        ref="formValorMoneda"
                        v-model="formValorMoneda"
                        :items="itemsFormValorMoneda"
                        :rules="showBanco ? [$rules.requerido] : []"
                        :error-messages="errorMessagesValor"
                        item-text="descripcion"
                        item-value="id"
                        label="Moneda"
                        required
                        hide-details
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="6" sm="6" md="6">
                      <v-text-field
                        color="icons"
                        outlined
                        reverse
                        dense
                        type="tel"
                        @change="
                          formValorImporte = $formatoNumero(formValorImporte)
                        "
                        ref="formValorImporte"
                        v-model="formValorImporte"
                        :rules="[$rules.numero, $rules.requerido]"
                        :error-messages="errorMessagesValor"
                        label="Importe"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      v-show="showBanco && valorTipoTipo == 3"
                    >
                      <v-text-field
                        color="icons"
                        outlined
                        reverse
                        dense
                        ref="formValorCodigo"
                        v-model="formValorCodigo"
                        :rules="
                          showBanco && valorTipoTipo == 3
                            ? [$rules.requerido]
                            : []
                        "
                        :error-messages="errorMessagesValor"
                        :label="
                          valorTipoTipo == 3
                            ? 'Número de Cheque'
                            : 'Número de Transferencia'
                        "
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="6" v-show="showBanco">
                      <v-autocomplete
                        dense
                        outlined
                        ref="formValorBanco"
                        v-model="formValorBanco"
                        :items="itemsFormValorBanco"
                        :rules="showBanco ? [$rules.requerido] : []"
                        :error-messages="errorMessagesValor"
                        @change="mostrarDescripcionBanco"
                        item-text="descripcion"
                        item-value="id"
                        :label="
                          valorTipoTipo == 3 ? 'Banco Emisor' : 'Banco Destino'
                        "
                        required
                        hide-details
                      >
                      </v-autocomplete>
                    </v-col>

                    <v-col cols="6" sm="6" md="6" v-show="showFechaValor">
                      <v-dialog
                        ref="dialogFecha"
                        v-model="modalFecha"
                        :return-value.sync="date"
                        persistent
                        width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            outlined
                            type="date"
                            readonly
                            dense
                            ref="formValorFecha"
                            v-model="formValorFecha"
                            :rules="showFechaValor ? [$rules.requerido] : []"
                            @click="modalFecha = true"
                            :error-messages="errorMessagesValor"
                            :label="
                              valorTipoTipo == 3
                                ? 'Fecha Emisión de Cheque'
                                : 'Fecha de Transferencia'
                            "
                            v-bind="attrs"
                            v-on="on"
                            required
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="formValorFecha" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="cancelFecha">
                            Cancel
                          </v-btn>
                          <v-btn text color="primary" @click="setFecha(date)">
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-col>

                    <v-col cols="12" sm="12" md="12" v-show="showBanco">
                      <v-file-input
                        dense
                        id="fileValor"
                        ref="fileValor"
                        v-model="fileValor"
                        @change="archivoCambiadoImagen"
                        counter
                        :rules="showBanco ? [$rules.requeridoArchivo] : []"
                        show-size
                        chips
                        accept="image/*"
                        prepend-icon="camera_alt"
                        placeholder="Seleccione una imagen"
                      >
                        <template v-slot:selection="{ text }">
                          <v-chip color="primary">
                            {{ text }}
                          </v-chip>
                        </template>
                      </v-file-input>
                    </v-col>

                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      v-show="
                        showBanco &&
                        valorTipoTipo != 3 &&
                        this.quitarformatoNumero(formValorImporte) >= 50000
                      "
                    >
                      <v-text-field
                        color="icons"
                        outlined
                        dense
                        type="text"
                        ref="formValorOrdenante"
                        v-model="formValorOrdenante"
                        :rules="
                          showBanco &&
                          valorTipoTipo != 3 &&
                          this.quitarformatoNumero(formValorImporte) >= 50000
                            ? [$rules.requerido]
                            : []
                        "
                        :error-messages="errorMessagesValor"
                        :label="'Ordenante '"
                        :hint="clienteObject.razon_social"
                        persistent-hint
                        required
                      ></v-text-field>
                    </v-col>

                    <v-col cols="6" sm="6" md="6" v-show="valorTipoTipo == 3">
                      <v-autocomplete
                        dense
                        outlined
                        ref="formValorBancoDestino"
                        v-model="formValorBancoDestino"
                        :items="itemsFormValorBanco"
                        :rules="valorTipoTipo == 3 ? [$rules.requerido] : []"
                        :error-messages="errorMessagesValor"
                        item-text="descripcion"
                        item-value="id"
                        label="Banco a depositar"
                        required
                        hide-details
                      >
                      </v-autocomplete>
                    </v-col>

                    <v-col cols="6" sm="6" md="6" v-show="valorTipoTipo == 3">
                      <v-dialog
                        ref="dialogFechaDeposito"
                        v-model="modalFechaDeposito"
                        :return-value.sync="date"
                        persistent
                        width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            outlined
                            type="date"
                            readonly
                            dense
                            ref="formValorFechaDeposito"
                            v-model="formValorFechaDeposito"
                            :rules="
                              valorTipoTipo == 3 ? [$rules.requerido] : []
                            "
                            @click="modalFechaDeposito = true"
                            :error-messages="errorMessagesValor"
                            label="Fecha Depósito de Cheque"
                            v-bind="attrs"
                            v-on="on"
                            required
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="formValorFechaDeposito"
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="cancelFechaDeposito"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="setFechaDeposito(date)"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-col>
                    <v-list>
                      <v-list-item-group>
                        <v-list-item color="white"> </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-row>
                </v-container>
              </v-sheet>

              <v-btn
                v-if="searchCodClienteFlag"
                color="success"
                fab
                large
                dark
                class="bottom-button"
                @click="saveValor"
                :loading="loadButton"
              >
                <v-icon>done</v-icon>
              </v-btn>
            </v-card>
          </v-flex>
        </v-layout>
      </v-dialog>

      <v-dialog
        v-model="dialogMu"
        persistent
        :fullscreen="false"
        :max-width="isMobile ? '100%' : '500px'"
        transition="dialog-bottom-transition"
      >
        <v-layout align-start v-resize="getDimensions">
          <v-flex>
            <v-card ref="form" :height="isMobile ? height - 75 : height - 100">
              <v-app-bar color="white" elevate-on-scroll flat>
                <v-card-title> Filtro Documento </v-card-title>
                <v-spacer></v-spacer>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      @click="closeFiltroDocumento"
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      fab
                    >
                      <v-icon dark> close </v-icon>
                    </v-btn>
                  </template>
                  <span>Cancelar</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      @click="clearFiltroDocumento"
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      fab
                    >
                      <v-icon dark> fa-solid fa-arrow-rotate-left </v-icon>
                    </v-btn>
                  </template>
                  <span>Borrar Filtros</span>
                </v-tooltip>
              </v-app-bar>
              <v-sheet
                class="overflow-y-auto"
                :max-height="isMobile ? height - 60 : height - 60"
              >
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-autocomplete
                        dense
                        outlined
                        ref="formFiltroDocumentoTipo"
                        v-model="formFiltroDocumentoTipo"
                        :items="itemsFormFiltroDocumentoTipo"
                        :rules="[]"
                        :error-messages="errorMessagesValor"
                        item-text="descripcion"
                        item-value="id"
                        label="Tipo de Documento"
                        required
                        hide-details
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-autocomplete
                        dense
                        outlined
                        ref="formFiltroDocumentoDireccion"
                        v-model="formFiltroDocumentoDireccion"
                        :items="itemsFormFiltroDocumentoDireccion"
                        :rules="[]"
                        :error-messages="errorMessagesValor"
                        item-text="descripcion"
                        item-value="id"
                        label="Direcciones"
                        required
                        hide-details
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-autocomplete
                        dense
                        outlined
                        ref="formFiltroFecha"
                        v-model="formFiltroFecha"
                        :items="itemsFormFiltroFecha"
                        :rules="[]"
                        :error-messages="errorMessagesValor"
                        item-text="descripcion"
                        item-value="id"
                        label="Fecha"
                        required
                        hide-details
                      >
                      </v-autocomplete>
                    </v-col>

                    <v-col cols="6" sm="6" md="6" v-show="formFiltroFecha == 7">
                      <v-dialog
                        v-model="modalFiltroFechaDesde"
                        :return-value.sync="date"
                        persistent
                        width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            outlined
                            type="date"
                            readonly
                            dense
                            ref="formFiltroFechaDesde"
                            v-model="formFiltroFechaDesde"
                            @click="modalFiltroFechaDesde = true"
                            label="Fecha desde"
                            v-bind="attrs"
                            v-on="on"
                            required
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="formFiltroFechaDesde"
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="modalFiltroFechaDesde = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="modalFiltroFechaDesde = false"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-col>
                    <v-col cols="6" sm="6" md="6" v-show="formFiltroFecha == 7">
                      <v-dialog
                        v-model="modalFiltroFechaHasta"
                        :return-value.sync="date"
                        persistent
                        width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            outlined
                            type="date"
                            readonly
                            dense
                            ref="formFiltroFechaHasta"
                            v-model="formFiltroFechaHasta"
                            @click="modalFiltroFechaHasta = true"
                            label="Fecha Hasta"
                            v-bind="attrs"
                            v-on="on"
                            required
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="formFiltroFechaHasta"
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="modalFiltroFechaHasta = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="modalFiltroFechaHasta = false"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-col>

                    <v-col cols="12" sm="12" md="12">
                      <v-autocomplete
                        dense
                        outlined
                        ref="formFiltroFechaVence"
                        v-model="formFiltroFechaVence"
                        :items="itemsFormFiltroFechaVence"
                        :rules="[]"
                        :error-messages="errorMessagesValor"
                        item-text="descripcion"
                        item-value="id"
                        label="Fecha Vencimiento"
                        required
                        hide-details
                      >
                      </v-autocomplete>
                    </v-col>

                    <v-col
                      cols="6"
                      sm="6"
                      md="6"
                      v-show="formFiltroFechaVence == 4"
                    >
                      <v-dialog
                        v-model="modalFiltroFechaVenceDesde"
                        :return-value.sync="date"
                        persistent
                        width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            outlined
                            type="date"
                            readonly
                            dense
                            ref="formFiltroFechaVenceDesde"
                            v-model="formFiltroFechaVenceDesde"
                            @click="modalFiltroFechaVenceDesde = true"
                            label="Fecha Vence Desde"
                            v-bind="attrs"
                            v-on="on"
                            required
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="formFiltroFechaVenceDesde"
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="modalFiltroFechaVenceDesde = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="modalFiltroFechaVenceDesde = false"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-col>
                    <v-col
                      cols="6"
                      sm="6"
                      md="6"
                      v-show="formFiltroFechaVence == 4"
                    >
                      <v-dialog
                        v-model="modalFiltroFechaVenceHasta"
                        :return-value.sync="date"
                        persistent
                        width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            outlined
                            type="date"
                            readonly
                            dense
                            ref="formFiltroFechaVenceHasta"
                            v-model="formFiltroFechaVenceHasta"
                            @click="modalFiltroFechaVenceHasta = true"
                            label="Fecha Vence Hasta"
                            v-bind="attrs"
                            v-on="on"
                            required
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="formFiltroFechaVenceHasta"
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="modalFiltroFechaVenceHasta = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="modalFiltroFechaVenceHasta = false"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-col>

                    <v-col cols="6" sm="6" md="6">
                      <v-text-field
                        color="icons"
                        outlined
                        reverse
                        dense
                        type="tel"
                        ref="formFiltroMontoDesde"
                        v-model="formFiltroMontoDesde"
                        :rules="[]"
                        :error-messages="errorMessagesValor"
                        label="Desde (Monto)"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="6">
                      <v-text-field
                        color="icons"
                        outlined
                        reverse
                        dense
                        type="tel"
                        ref="formFiltroMontoHasta"
                        v-model="formFiltroMontoHasta"
                        :rules="[$rules.numero, $rules.requerido]"
                        :error-messages="errorMessagesValor"
                        label="Hasta (Monto)"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-list>
                      <v-list-item-group>
                        <v-list-item color="white"> </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-row>
                </v-container>
              </v-sheet>

              <v-btn
                color="success"
                fab
                large
                @click="filtrarDocumentos"
                dark
                class="bottom-button"
              >
                <v-icon>fa-solid fa-search</v-icon>
              </v-btn>
            </v-card>
          </v-flex>
        </v-layout>
      </v-dialog>

      <v-dialog
        v-model="dialogXi"
        persistent
        :fullscreen="false"
        :max-width="isMobile ? '100%' : '500px'"
        transition="dialog-bottom-transition"
      >
        <v-layout align-start v-resize="getDimensions">
          <v-flex>
            <v-card ref="form" :height="isMobile ? height - 75 : height - 100">
              <v-app-bar color="white" elevate-on-scroll flat>
                <v-card-title> Filtro Medios de Pago </v-card-title>
                <v-spacer></v-spacer>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      @click="closeFiltroValor"
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      fab
                    >
                      <v-icon dark> close </v-icon>
                    </v-btn>
                  </template>
                  <span>Cancelar</span>
                </v-tooltip>
              </v-app-bar>
              <v-sheet
                class="overflow-y-auto"
                :max-height="isMobile ? height - 60 : height - 60"
              >
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-autocomplete
                        dense
                        outlined
                        ref="formFiltroValorTipo"
                        v-model="formFiltroValorTipo"
                        :items="itemsFormValorTipo"
                        :rules="[$rules.requerido]"
                        :error-messages="errorMessagesValor"
                        item-text="descripcion"
                        item-value="id"
                        label="Tipo de Valor"
                        required
                        hide-details
                      >
                      </v-autocomplete>
                    </v-col>

                    <v-container fluid>
                      <v-row>
                        <v-col cols="6" sm="6" md="6">
                          <v-text-field
                            color="icons"
                            outlined
                            reverse
                            dense
                            type="tel"
                            ref="formFiltroMontoDesde"
                            v-model="formFiltroMontoDesde"
                            :rules="[$rules.numero, $rules.requerido]"
                            :error-messages="errorMessagesValor"
                            label="Desde (Monto)"
                            required
                          ></v-text-field>

                          <v-dialog
                            v-model="modalFiltroFechaDesde"
                            :return-value.sync="date"
                            persistent
                            width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                outlined
                                type="date"
                                readonly
                                dense
                                ref="formFiltroFechaDesde"
                                v-model="formFiltroFechaDesde"
                                @click="modalFiltroFechaDesde = true"
                                label="Fecha desde"
                                v-bind="attrs"
                                v-on="on"
                                required
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="formFiltroFechaDesde"
                              scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="modalFiltroFechaDesde = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="modalFiltroFechaDesde = false"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-dialog>
                        </v-col>

                        <v-col cols="6" sm="6" md="6">
                          <v-text-field
                            color="icons"
                            outlined
                            reverse
                            dense
                            type="tel"
                            ref="formFiltroMontoHasta"
                            v-model="formFiltroMontoHasta"
                            :rules="[$rules.numero, $rules.requerido]"
                            :error-messages="errorMessagesValor"
                            label="Hasta (Monto)"
                            required
                          ></v-text-field>
                          <v-dialog
                            v-model="modalFiltroFechaHasta"
                            :return-value.sync="date"
                            persistent
                            width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                outlined
                                type="date"
                                readonly
                                dense
                                ref="formFiltroFechaHasta"
                                v-model="formFiltroFechaHasta"
                                @click="modalFiltroFechaHasta = true"
                                label="Fecha Hasta"
                                v-bind="attrs"
                                v-on="on"
                                required
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="formFiltroFechaHasta"
                              scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="modalFiltroFechaHasta = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="modalFiltroFechaHasta = false"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-dialog>
                        </v-col>
                        <v-list>
                          <v-list-item-group>
                            <v-list-item color="white"> </v-list-item>
                          </v-list-item-group>
                        </v-list>
                      </v-row>
                    </v-container>
                  </v-row>
                </v-container>
              </v-sheet>

              <v-btn
                color="success"
                fab
                large
                @click="filtrarValores"
                dark
                class="bottom-button"
              >
                <v-icon>fa-solid fa-search</v-icon>
              </v-btn>
            </v-card>
          </v-flex>
        </v-layout>
      </v-dialog>

      <v-dialog v-model="dialogOmega" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Generación de Recibo</v-card-title>
          <v-card-text>
            <div>
              Se generará el RECIBO N° {{ codigoRecibo }} con los siguientes
              datos:
            </div>
            <div>
              Cliente:
              {{
                "(" + clienteObject.codigo + ") " + clienteObject.descripcion
              }}
            </div>
            <div>Fecha: {{ this.fechaActual }}</div>
            <div>Ajuste: {{ ajusteRecibo }}</div>
            <div v-if="cantidadFacturas > 0">
              Facturas: {{ cantidadFacturas }}, por un valor de
              {{ $formatoNumero(sumaFacturas) }}
            </div>
            <div v-if="cantidadNotas > 0">
              Notas de Crédito: {{ cantidadNotas }}, por un valor de
              {{ $formatoNumero(sumaNotas) }}
            </div>
            <div v-if="dtValorElegido.length > 0">
              Medios de Pago: {{ dtValorElegido.length }}, por un valor de
              {{ $formatoNumero(importeValorElegido) }}
            </div>
            <div>¿Desea continuar?</div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogOmega = false" :loading="loadButton"
              >Cancelar</v-btn
            >
            <v-btn
              color="primary"
              text
              @click="saveRecibo()"
              :loading="loadButton"
              >Continuar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<style>
/* This is for documentation purposes and will not be needed in your application */
.floating-button {
  bottom: 0;
  right: 0;
  width: 90%;
  position: fixed;
  margin: 16px 16px 16px 16px;
}

.bottom-button {
  bottom: 0;
  right: 0;
  width: 90%;
  position: absolute;
  margin: 16px 16px 16px 16px;
}
</style>
<script>
import axios from "axios";
import dialogMixin from "../plugins/dialogs.js";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import QRCode from "qrcodejs2";
import KardexBonos from "@/components/Kardex/DialogTableKardex.vue";
import ClientCard from "@/components/Cliente/ClienteCard.vue";
import MapaConMarcador from "@/components/Mapas/MapaConMarcador.vue";
import LocationMap from "@/components/Mapas/LocationMap.vue";

export default {
  mixins: [dialogMixin],
  components: {
    KardexBonos,
    ClientCard,
    MapaConMarcador,
    LocationMap,
  },
  data() {
    return {
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false /* doesn't work with directive */,
      },
      //variables globales
      usuario: this.$store.state.usuario.user,
      nombreUsuario: this.$store.state.usuario.nombre,
      idUsuario: this.$store.state.usuario.idUsuario,
      rol: this.$store.state.usuario.rol,

      //Varibles Cliente
      clienteObject: {},

      foto_recibo: "",
      estado_recibo: "",

      showSearchCliente: true,
      typeSearchCliente: true,
      awaitingSearchCliente: false,
      searchCodCliente: "",
      countCharCliente: 0,
      dtCliente: [],
      loadCliente: false,
      loadButton: false,
      loadGenerico: false,
      selectedCliente: [],
      idValorDocumento: 0,

      location: {},
      errorLocation: null,

      total_documento: 0,
      total_valor: 0,
      total_ajuste: 0,
      moneda: "",

      //Variables de formato global
      width: 0,
      height: 0,
      isMobile: false,

      //Variables de recibo
      dialogAlpha: false,
      dialogBeta: false,
      showSearchRecibo: false,
      searchRecibo: "",
      selectedRecibo: [],
      talonarioRecibo: "",
      itemsTalonarioRecibo: [],

      mensajeConfirmacionRecibo: "",
      dialogOmega: false,

      idRecibo: 0,
      codigoRecibo: "",
      descripcionRecibo: "",
      fechaRecibo: "",
      fechaActual: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      valorRecibo: "",
      documentoRecibo: "",
      balanceRecibo: "",
      ajusteRecibo: "",
      tipoAjusteRecibo: true,
      descuentoRecibo: "",
      errorMessagesRecibo: "",
      errorMessagesForm: "",
      dtRecibo: [],
      //variables de documentos
      dialogGamma: false,
      showSearchDocumentoElegido: false,
      showSearchDocumentoLista: false,
      searchDocumentoElegido: "",
      searchDocumentoLista: "",
      selectedDocumentoElegido: [],
      selectedDocumentoLista: [],

      selectedDocLista: [],
      selectedValLista: [],
      selectedDocElegido: [],
      detailDocumentoLista: "Sin documentos seleccionados",
      detailValorLista: "Sin pagos seleccionados",
      detailDocumentoElegido: "Sin documentos seleccionados",
      detailValorElegido: "Sin pagos seleccionados",

      formDocCodigo: "",
      formDocDescripcion: "",
      formDocEstado: "",
      formDocFecha: "",
      formDocImporte: "",
      formDocSaldo: "",
      formDocSubtotal: "",
      formDocTipo: "",
      formDocSaldoAnt: "",

      flagFiltroDoc: false,
      flagFiltroVal: false,

      cantidadDocumentoLista: 0,
      cantidadDocumentoElegido: 0,

      cantidadValorLista: 0,
      cantidadValorElegido: 0,

      importeDocumentoLista: 0,
      importeDocumentoElegido: 0,

      dtDocumentoLista: [],
      dtDocumentoElegido: [],
      bancarizacion: 0,

      dialogDelta: false,
      dialogNu: false,
      dialogIota: false,

      //variables de valores

      dialogKappa: false,
      dialogLambda: false,
      errorMessagesValor: "",
      searchValorElegido: "",
      searchValorLista: "",
      showSearchValorElegido: false,
      showSearchValorLista: false,
      selectedValorLista: [],
      selectedValorElegido: [],
      dtValorLista: [],
      dtValorElegido: [],
      modalFecha: false,
      modalFechaDeposito: false,
      fileValor: null,

      modalFiltroFechaDesde: false,
      modalFiltroFechaHasta: false,
      modalFiltroFechaVenceDesde: false,
      modalFiltroFechaVenceHasta: false,

      cantidadFacturas: 0,
      cantidadNotas: 0,
      sumaFacturas: 0,
      sumaNotas: 0,

      formFiltroMontoDesde: "",
      formFiltroMontoHasta: "",

      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),

      formValorId: 1,
      formValorCodigo: "",
      formValorImporte: "",
      formValorOrdenante: "",
      formValorTipo: "",
      formValorBanco: "",
      formValorBancoDestino: "",
      formValorMoneda: "Bs.",

      formValorFecha: "",
      formValorFechaDeposito: "",
      formFiltroFechaDesde: "",
      formFiltroFechaHasta: "",
      formFiltroFechaVenceDesde: "",
      formFiltroFechaVenceHasta: "",
      formFiltroDocumentoTipo: "",
      formFiltroDocumentoDireccion: "",
      formFiltroValorTipo: "",
      descripcionBanco: "",

      showFecha: false,
      showFechaVence: false,
      searchCodClienteFlag: true,

      formValorEditado: false,
      showFechaValor: false,
      showBanco: false,
      valida: 0,
      showSearchValorLista: false,
      showSearchValorElegido: false,

      valorTipoId: 0,
      valorTipoDescripcion: "",
      valorTipoTipo: "",

      itemsFormValorTipo: [],
      itemsFormValorBanco: [],
      itemsFormFiltroDocumentoDireccion: [],
      itemsFormValorMoneda: [
        { id: "Bs.", descripcion: "BOLIVIANOS" },
        { id: "USD", descripcion: "DOLARES" },
      ],

      itemsFormFiltroDocumentoTipo: [
        { id: "F", descripcion: "FACTURA" },
        { id: "C", descripcion: "NOTA DE CRÉDITO" },
      ],

      itemsFormFiltroFecha: [
        { id: "1", descripcion: "Hoy" },
        { id: "2", descripcion: "Ayer" },
        { id: "3", descripcion: "Últimos 7 días" },
        { id: "4", descripcion: "Últimos 30 días" },
        { id: "5", descripcion: "Últimos 90 días" },
        { id: "6", descripcion: "Último año" },
        { id: "7", descripcion: "Personalizado" },
      ],
      itemsFormFiltroFechaVence: [
        { id: "1", descripcion: "Vencidas" },
        { id: "2", descripcion: "Próximas a vencer" },
        { id: "3", descripcion: "Vigentes" },
        { id: "4", descripcion: "Personalizado" },
      ],

      formFiltroFecha: "",
      formFiltroFechaVence: "",

      esPagoElectronico: false,
      metodoPagoCambiado: false,
      importeValorElegido: 0,
      importeValorLista: 0,
      cantidadValor: 0,

      dialogMu: false,
    };
  },

  watch: {
    typeSearchCliente: function (val) {
      this.countCharCliente = this.searchCodCliente.length;

      if (this.countCharCliente > 2) {
        this.loadCliente = true;
        this.listarClientes();
      }
    },

    searchCodCliente: function (val) {
      if (!this.awaitingSearchCliente) {
        setTimeout(() => {
          this.countCharCliente = this.searchCodCliente.length;

          if (this.countCharCliente > 1) {
            this.loadCliente = true;
            this.listarClientes();
          } else {
            this.loadCliente = false;
            this.dtCliente = [];
          }
          this.awaitingSearchCliente = false;
        }, 2000); // 1 sec delay
      }
      this.awaitingSearchCliente = true;
    },

    ajusteRecibo: function (val) {
      this.calcularBalance();
    },
    tipoAjusteRecibo: function (val) {
      this.calcularBalance();
    },
  },

  mounted() {
    this.getDimensions();
  },

  created() {
    if (this.idUsuario === undefined) {
      this.$store.dispatch("salir");
    }

    this.$store.dispatch("actualizarTitulo", "Clientes");

    //this.selectValores(0);
    //this.selectBancos();
    this.selectTalonarios();
  },
  beforeDestroy() {
    this.$store.dispatch("actualizarTitulo", "");
  },

  computed: {
    filtrarDtRecibo() {
      return _.orderBy(
        this.dtRecibo.filter((item) => {
          if (!this.searchRecibo) return this.dtRecibo;
          return (
            (item.id.toString() || "")
              .toLowerCase()
              .includes(this.searchRecibo.toLowerCase()) ||
            (item.codigo || "")
              .toLowerCase()
              .includes(this.searchRecibo.toLowerCase()) ||
            (item.descripcion || "")
              .toLowerCase()
              .includes(this.searchRecibo.toLowerCase()) ||
            (item.estado || "")
              .toLowerCase()
              .includes(this.searchRecibo.toLowerCase())
          );
        }),
        "headline"
      );
    },

    filtrarDtDocumentoLista() {
      if (this.dtDocumentoLista.length > 0) {
        return _.orderBy(
          this.dtDocumentoLista.filter((item) => {
            if (!this.searchDocumentoLista) return this.dtDocumentoLista;
            return (
              (item.id.toString() || "")
                .toLowerCase()
                .includes(this.searchDocumentoLista.toLowerCase()) ||
              (item.codigo || "")
                .toLowerCase()
                .includes(this.searchDocumentoLista.toLowerCase()) ||
              (item.importe.toString() || "")
                .toLowerCase()
                .includes(this.searchDocumentoLista.toLowerCase()) ||
              (item.sucur_nombre || "")
                .toLowerCase()
                .includes(this.searchDocumentoLista.toLowerCase()) ||
              (item.fecha.toString() || "")
                .toLowerCase()
                .includes(this.searchDocumentoLista.toLowerCase()) ||
              (item.venci_fecha.toString() || "")
                .toLowerCase()
                .includes(this.searchDocumentoLista.toLowerCase())
            );
          }),
          "headline"
        );
      } else {
        return [];
      }
    },
    filtrarDtValorLista() {
      if (this.dtValorLista.length > 0) {
        return _.orderBy(
          this.dtValorLista.filter((item) => {
            if (!this.searchValorLista) return this.dtValorLista;
            return (
              (item.id.toString() || "")
                .toLowerCase()
                .includes(this.searchValorLista.toLowerCase()) ||
              (item.codigo || "")
                .toLowerCase()
                .includes(this.searchValorLista.toLowerCase()) ||
              (item.monto.toString() || "")
                .toLowerCase()
                .includes(this.searchValorLista.toLowerCase()) ||
              (item.fecha.toString() || "")
                .toLowerCase()
                .includes(this.searchValorLista.toLowerCase())
            );
          }),
          "headline"
        );
      } else {
        return [];
      }
    },
    filtrarDtValorElegido() {
      if (this.dtValorElegido.length > 0) {
        return _.orderBy(
          this.dtValorElegido.filter((item) => {
            if (!this.searchValorElegido) return this.dtValorElegido;
            return (
              (item.id.toString() || "")
                .toLowerCase()
                .includes(this.searchValorElegido.toLowerCase()) ||
              (item.codigo || "")
                .toLowerCase()
                .includes(this.searchValorElegido.toLowerCase()) ||
              (item.monto.toString() || "")
                .toLowerCase()
                .includes(this.searchValorElegido.toLowerCase()) ||
              (item.fecha.toString() || "")
                .toLowerCase()
                .includes(this.searchValorElegido.toLowerCase())
            );
          }),
          "headline"
        );
      } else {
        return [];
      }
    },
    filtrarDtDocumentoElegido() {
      return _.orderBy(
        this.dtDocumentoElegido.filter((item) => {
          if (!this.searchDocumentoElegido) return this.dtDocumentoElegido;
          return (
            (item.id.toString() || "")
              .toLowerCase()
              .includes(this.searchDocumentoElegido.toLowerCase()) ||
            (item.codigo || "")
              .toLowerCase()
              .includes(this.searchDocumentoElegido.toLowerCase()) ||
            (item.descripcion || "")
              .toLowerCase()
              .includes(this.searchDocumentoElegido.toLowerCase()) ||
            (item.estado || "")
              .toLowerCase()
              .includes(this.searchDocumentoElegido.toLowerCase())
          );
        }),
        "headline"
      );
    },
    filtrardtValorLista() {
      return _.orderBy(
        this.dtValorLista.filter((item) => {
          if (!this.searchValor) return this.dtValorLista;
          return (
            (item.id.toString() || "")
              .toLowerCase()
              .includes(this.searchValor.toLowerCase()) ||
            (item.codigo || "")
              .toLowerCase()
              .includes(this.searchValor.toLowerCase()) ||
            (item.descripcion || "")
              .toLowerCase()
              .includes(this.searchValor.toLowerCase()) ||
            (item.estado || "")
              .toLowerCase()
              .includes(this.searchValor.toLowerCase())
          );
        }),
        "headline"
      );
    },

    formRecibo() {
      return {
        documentoRecibo: this.documentoRecibo,
        valorRecibo: this.valorRecibo,
        ajusteRecibo: this.ajusteRecibo,
        balanceRecibo: this.balanceRecibo,
      };
    },
    formValor() {
      return {
        formValorBanco: this.formValorBanco,
        formValorBancoDestino: this.formValorBancoDestino,
        formValorMoneda: this.formValorMoneda,
        formValorTipo: this.formValorTipo,
        formValorCodigo: this.formValorCodigo,
        formValorImporte: this.formValorImporte,
        formValorOrdenante: this.formValorOrdenante,
        formValorFecha: this.formValorFecha,
        formValorFechaDeposito: this.formValorFechaDeposito,
        fileValor: this.fileValor,
      };
    },
  },
  methods: {
    handleLocationSaved(location) {
      this.clienteObject.latitud = location.lat;
      this.clienteObject.longitud = location.lng;
    },

    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.location = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            };
            this.errorLocation = null;
          },
          (error) => {
            this.errorLocation = "Active y autorice el uso de su ubicación.";
          }
        );
      } else {
        this.errorLocation =
          "La geolocalización no es compatible con este navegador.";
      }
    },
    getDimensions() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
      this.isMobile = this.width < 768;
    },

    archivoCambiadoImagen(e) {
      this.selectedFile = e;
      if (e != null) {
        this.foto = URL.createObjectURL(this.selectedFile);
      } else {
        this.foto = "/uploads/student.png";
      }
    },

    clearSearchCliente() {
      this.searchCodCliente = "";
      this.dtCliente = [];
    },

    listarClientes() {
      let me = this;
      var cod = "";
      var des = "";

      if (this.typeSearchCliente) {
        cod =
          me.searchCodCliente == null ||
          me.searchCodCliente == undefined ||
          me.searchCodCliente == ""
            ? "__"
            : me.searchCodCliente;
        des = "__";
      } else {
        des =
          me.searchCodCliente == null ||
          me.searchCodCliente == undefined ||
          me.searchCodCliente == ""
            ? "__"
            : me.searchCodCliente;
        cod = "__";
      }

      axios
        .get("api/clientes/listar/" + cod + "/" + des + "/" + me.usuario)
        .then(function (response) {
          me.dtCliente = response.data;
          me.loadCliente = false;
        })
        .catch(function (error) {
          me.loadCliente = false;
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },

    listarRecibo() {
      let me = this;
      axios
        .get(
          "api/recibos/ListarPorCliente/" +
            this.clienteObject.id +
            "/" +
            this.usuario
        )
        .then(function (response) {
          me.dtRecibo = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },

    imprimirRecibo(item) {
      let me = this;

      me.codigoRecibo = item.numero_recibo;

      axios
        .get("api/valores/ListarPorRecibo/" + item.id)
        .then(function (response) {
          me.dtValorElegido = response.data;
          me.fnDetalleDocumentoElegido();
          axios
            .get("api/documentos/ListarPorRecibo/" + item.id)
            .then(function (response) {
              me.dtDocumentoElegido = response.data;
              me.fnDetalleDocumentoElegido();
              axios
                .get("api/recibos/obtenerAjuste/" + item.id)
                .then(function (response) {
                  me.ajusteRecibo = response.data;
                  me.generarPDF();
                })
                .catch(function (error) {
                  me.$store.dispatch("setSnackbar", {
                    text:
                      error == "Error: Network Error"
                        ? "No se pudo conectar con el servidor"
                        : error,
                    color: "error",
                  });
                });
            })
            .catch(function (error) {
              me.$store.dispatch("setSnackbar", {
                text:
                  error == "Error: Network Error"
                    ? "No se pudo conectar con el servidor"
                    : error,
                color: "error",
              });
            });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },

    obtenerCodigoRecibo() {
      let me = this;
      axios
        .get("api/recibos/obtenerCodigo/" + this.talonarioRecibo)
        .then(function (response) {
          me.codigoRecibo = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },

    showListRecibo(active, item) {
      this.dialogAlpha = true;
      this.clienteObject = item;

      this.listarRecibo();
    },

    closeListRecibo() {
      this.dialogAlpha = false;
      this.selectedCliente = [];
    },

    showRecibo(row) {
      this.idRecibo = row.id;
      this.codigoRecibo = row.numero_recibo;
      this.descripcionRecibo = row.descripcion;
      this.documentoRecibo = row.documento;
      this.valorRecibo = row.valor;
      this.fechaRecibo = this.$formatoFecha(row.fecha);
      this.foto_recibo = row.foto_recibo;
      this.estado_recibo = row.estado;
      this.total_ajuste = row.total_ajuste;
      this.total_documento = row.total_documento;
      this.total_valor = row.total_valor;
      this.moneda = row.moneda;
      this.ajusteRecibo = "0";
      this.dialogSigma = true;
      this.obtenerDetallesRecibo(row);
    },
    cleanRecibo() {
      this.codigoRecibo = "";
      this.esPagoElectronico = false;
      this.talonarioRecibo = "";
      this.descripcionRecibo = "";
      this.documentoRecibo = "";
      this.valorRecibo = "";
      this.balanceRecibo = "";
      this.fechaRecibo = this.$formatoFecha(this.fechaActual);
      this.balanceRecibo = "0.00";
      this.ajusteRecibo = "0.00";
      this.selectedRecibo = [];
      this.dtDocumentoElegido = [];
      this.dtDocumentoLista = [];
      this.dtValorLista = [];
      this.dtValorElegido = [];

      this.detailDocumentoLista = "Sin documentos seleccionados";
      this.detailDocumentoElegido = "Sin documentos seleccionados";
      this.detailValorElegido = "Sin medios de pago seleccionados";
      this.detailValorLista = "Sin medios de pago seleccionados";
      this.importeDocumentoElegido = 0;
      this.importeDocumentoLista = 0;
      this.importeValorElegido = 0;
      this.importeValorLista = 0;
    },

    closeRecibo() {
      this.dialogBeta = false;
      this.eliminarValoresDocumento();

      this.cleanRecibo();
    },
    closeActualizarCliente() {
      this.dialogTau = false;
    },
    closeReciboDetalle() {
      this.dialogSigma = false;
      this.eliminarValoresDocumento();

      this.cleanRecibo();
    },

    mostrarConfirmacion() {
      this.getLocation();
      if (this.errorLocation !== null) {
        this.$store.dispatch("setSnackbar", {
          text: this.error,
          color: "error",
        });
        return;
      }

      if (this.validarRecibo() > 0) {
        return;
      }
      this.dialogOmega = true;
      var filasDocumento = this.dtDocumentoElegido.length * 7;
      var filasValor = this.dtValorLista.length * 7;

      this.mensajeConfirmacionRecibo =
        "Se generará el recibo " +
        this.codigoRecibo +
        " con los siguientes datos: <br>" +
        "Cliente: " +
        this.clienteObject.codigo +
        " - " +
        this.clienteObject.descripcion +
        "\n" +
        "Fecha: " +
        this.fechaRecibo +
        "\n" +
        "Ajuste: " +
        this.ajusteRecibo +
        "\n\n" +
        "Se seleccionaron " +
        this.dtDocumentoElegido.length +
        " factura(s) por un valor de " +
        this.$formatoNumero(this.importeDocumentoElegido) +
        " y " +
        this.dtValorElegido.length +
        " medio(s) de pago por un valor de " +
        this.$formatoNumero(this.importeValorElegido) +
        "\n\n";
    },

    guardarCliente() {
      if (this.clienteObject.nombre_contacto == "") {
        this.$store.dispatch("setSnackbar", {
          text: "Debe ingresar el nombre del contacto",
          color: "error",
        });
        return;
      }

      if (this.clienteObject.telefono_contacto == "") {
        this.$store.dispatch("setSnackbar", {
          text: "Debe ingresar el teléfono del contacto",
          color: "error",
        });
        return;
      }

      //verificamos que el telefono de contacto no sea nulo y que tenga 8 caracteres
      if (this.clienteObject.telefono_contacto) {
        if (this.clienteObject.telefono_contacto.length !== 8) {
          this.$store.dispatch("setSnackbar", {
            text: "El teléfono de contacto debe tener 8 caracteres",
            color: "error",
          });
          return;
        }
        //validamos que el telefono de contacto empiece con 7 o 6
        if (
          !(
            this.clienteObject.telefono_contacto.charAt(0) === "7" ||
            this.clienteObject.telefono_contacto.charAt(0) === "6"
          )
        ) {
          this.$store.dispatch("setSnackbar", {
            text: "El teléfono de contacto debe empezar con 7 o 6",
            color: "error",
          });
          return;
        }
      } else {
        this.$store.dispatch("setSnackbar", {
          text: "Debe ingresar el teléfono del contacto",
          color: "error",
        });
        return;
      }

      this.loadButton = true;
      let me = this;

      //agregamos el usuario actual al objeto cliente
      this.clienteObject.usuario = this.usuario;

      axios
        .put("api/clientes/actualizar", this.clienteObject)
        .then(function (response) {
          me.$store.dispatch("setSnackbar", {
            text: response.data,
            color: "success",
          });
          me.dialogTau = false;
          me.loadButton = false;
          me.listarClientes();
        })
        .catch(function (error) {
          me.loadButton = false;
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },

    addRecibo(item) {
      this.getLocation();
      if (
        this.error === "Active y autorice el uso de su ubicación para continuar"
      ) {
        this.$store.dispatch("setSnackbar", {
          text: this.error,
          color: "error",
        });
        return;
      }

      this.cleanRecibo();
      this.clienteObject = item;
      this.talonarioRecibo = this.itemsTalonarioRecibo.length===0?"0": this.itemsTalonarioRecibo[0].codigo;
      this.dtValorElegido = [];
      this.dtDocumentoElegido = [];
      this.obtenerCodigoRecibo();
      this.selectDirecciones();
      //this.obtenerCodigoRecibo();
      this.dialogBeta = true;
    },

    actualizarCliente(item) {
      this.clienteObject = item;

      this.dialogTau = true;
    },

    showDocumento() {
      this.dialogGamma = true;
    },

    showFiltroDocumentoLista() {
      this.dialogMu = true;
    },
    showFiltroValorLista() {
      this.dialogXi = true;
    },

    showFinderDocumentoLista() {
      this.showSearchDocumentoLista = !this.showSearchDocumentoLista;
      this.searchDocumentoLista = "";
    },
    showFinderDocumentoElegido() {
      this.showSearchDocumentoElegido = !this.showSearchDocumentoElegido;
      this.searchDocumentoElegido = "";
    },
    showFinderValorLista() {
      this.showSearchValorLista = !this.showSearchValorLista;
      this.searchValorLista = "";
    },

    showFinderValorElegido() {
      this.showSearchValorElegido = !this.showSearchValorElegido;
      this.searchValorElegido = "";
    },

    showDetailDocumentoLista(active, item, id) {
      if (!active) {
        this.selectedDocLista.push(item);
      } else {
        let indice = this.selectedDocLista.findIndex((i) => i.id === item.id);

        this.selectedDocLista.splice(indice, 1);
      }
      this.importeDocumentoLista = 0;
      this.cantidadDocumentoLista = 0;

      this.selectedDocLista.forEach((element) => {
        this.importeDocumentoLista =
          this.importeDocumentoLista + parseFloat(element.subtotal);
        this.cantidadDocumentoLista += 1;
      });
      this.importeDocumentoLista = this.redondear(this.importeDocumentoLista);
      this.cantidadDocumentoLista == 0
        ? (this.detailDocumentoLista = "Sin documentos seleccionados")
        : (this.detailDocumentoLista =
            this.cantidadDocumentoLista +
            (this.cantidadDocumentoLista === 1
              ? " documento = "
              : " documentos = ") +
            this.$formatoNumero(this.importeDocumentoLista) +
            " Bs.");
    },
    showDetailValorLista(active, item, id) {
      if (!active) {
        this.selectedValLista.push(item);
      } else {
        let indice = this.selectedValLista.findIndex((i) => i.id === item.id);

        this.selectedValLista.splice(indice, 1);
      }
      this.importeValorLista = 0;
      this.cantidadValorLista = 0;

      this.selectedValLista.forEach((element) => {
        this.importeValorLista =
          this.importeValorLista + parseFloat(element.monto);
        this.cantidadValorLista += 1;
      });
      this.importeValorLista = this.redondear(this.importeValorLista);
      this.cantidadValorLista == 0
        ? (this.detailValorLista = "Sin pagos seleccionados")
        : (this.detailValorLista =
            this.cantidadValorLista +
            (this.cantidadValorLista === 1 ? " pago = " : " pagos = ") +
            this.$formatoNumero(this.importeValorLista) +
            " Bs.");
    },

    saveDocumentoLista() {
      this.dialogDelta = false;
      this.bancarizacion = 0;
      this.selectValores(0, "N");
      this.selectBancos("N");
      this.selectedDocLista.forEach((element) => {
        this.dtDocumentoElegido.push(element);
        if (element.banca == 1) {
          this.bancarizacion += 1;
        }
      });

      //quitamos los items de la lista de documentos
      /*this.selectedDocLista.forEach((element) => {
          let indice = this.dtDocumentoLista.findIndex(
            (i) => i.codigo === element.codigo
          );
          this.dtDocumentoLista.splice(indice, 1);
        });*/
      this.dtDocumentoLista = [];
      this.selectedDocLista = [];
      this.selectedDocumentoLista = [];
      this.importeDocumentoLista = 0;
      this.cantidadDocumentoLista = 0;

      this.fnDetalleDocumentoElegido();
      if (this.bancarizacion > 0) {
        //borramos los valores de la lista de valores
        this.dtValorLista = [];
        this.selectedValorElegido = [];
        this.detailValorElegido = "Sin medios de pago seleccionados";
        this.importeValorElegido = 0;
        this.selectValores(this.bancarizacion, "T");
        this.selectBancos("T");
      }

      this.detailDocumentoLista = "Sin documentos seleccionados";
    },
    saveValorLista() {
      var auxiliar = [...this.dtValorElegido];

      this.selectedValLista.forEach((element) => {
        this.dtValorElegido.push(element);
      });

      if (!this.todasLasFechasSonIguales(this.dtValorElegido)) {
        this.$store.dispatch("setSnackbar", {
          text: "Debe ingresar Medios de pago con la misma fecha.",
          color: "error",
        });
        this.dtValorElegido = [...auxiliar];

        return;
      }
      this.dialogNu = false;

      this.selectValores(0, "N");
      this.selectBancos("N");

      //quitamos los items de la lista de Valors
      this.selectedValLista.forEach((element) => {
        let indice = this.dtValorLista.findIndex((i) => i.id === element.id);
        this.dtValorLista.splice(indice, 1);
      });
      this.selectedValLista = [];
      this.selectedValorLista = [];
      this.importeValorLista = 0;
      this.cantidadValorLista = 0;

      this.fnDetalleValorElegido();

      this.detailValorLista = "Sin pagos seleccionados";
    },

    todasLasFechasSonIguales(objetos) {
      if (objetos.length === 0) {
        return true;
      }

      var fechaReferencia = objetos[0].fecha;
      var f1 = this.$formatoFecha(fechaReferencia);
      var f2 = "";

      for (var i = 1; i < objetos.length; i++) {
        f2 = this.$formatoFecha(objetos[i].fecha);

        if (f1 !== f2) {
          return false;
        }
      }

      return true;
    },
    verificarFechaValores(objeto, fechaReferencia) {
      var f1 = this.$formatoFecha(fechaReferencia);
      var f2 = "";

      if (objeto.length === 0) {
        return true;
      }

      for (var i = 0; i < objeto.length; i++) {
        f2 = this.$formatoFecha(objeto[i].fecha);

        if (f1 !== f2) {
          return false;
        }
      }
      return true;
    },

    fnDetalleDocumentoLista() {
      this.importeDocumentoLista = 0;
      this.cantidadDocumentoLista = 0;
      this.cantidadFacturas = 0;
      this.cantidadNotas = 0;
      this.sumaFacturas = 0;
      this.sumaNotas = 0;
      this.dtDocumentoLista.forEach((element) => {
        if (element.compro_tipo == "F") {
          this.cantidadFacturas += 1;
          this.sumaFacturas += parseFloat(element.subtotal);
        } else {
          this.cantidadNotas += 1;
          this.sumaNotas += parseFloat(element.subtotal);
        }
        this.importeDocumentoLista =
          this.importeDocumentoLista + parseFloat(element.subtotal);
        this.cantidadDocumentoLista += 1;
      });
      this.importeDocumentoLista = this.redondear(this.importeDocumentoLista);

      this.cantidadDocumentoLista == 0
        ? (this.detailDocumentoLista = "Sin documentos seleccionados")
        : (this.detailDocumentoLista =
            this.cantidadDocumentoLista +
            (this.cantidadDocumentoLista === 1
              ? " documento = "
              : " documentos = ") +
            this.$formatoNumero(this.importeDocumentoLista) +
            " Bs.");
    },
    fnDetalleDocumentoElegido() {
      this.importeDocumentoElegido = 0;
      this.cantidadDocumentoElegido = 0;
      this.cantidadFacturas = 0;
      this.cantidadNotas = 0;
      this.sumaFacturas = 0;
      this.sumaNotas = 0;
      this.dtDocumentoElegido.forEach((element) => {
        if (element.compro_tipo == "F") {
          this.cantidadFacturas += 1;
          this.sumaFacturas += parseFloat(element.subtotal);
        } else {
          this.cantidadNotas += 1;
          this.sumaNotas += parseFloat(element.subtotal);
        }
        this.importeDocumentoElegido =
          this.importeDocumentoElegido + parseFloat(element.subtotal);
        this.cantidadDocumentoElegido += 1;
      });
      this.importeDocumentoElegido = this.redondear(
        this.importeDocumentoElegido
      );

      this.cantidadDocumentoElegido == 0
        ? (this.detailDocumentoElegido = "Sin documentos seleccionados")
        : (this.detailDocumentoElegido =
            this.cantidadDocumentoElegido +
            (this.cantidadDocumentoElegido === 1
              ? " documento = "
              : " documentos = ") +
            this.$formatoNumero(this.importeDocumentoElegido) +
            " Bs.");
    },
    fnDetalleValorElegido() {
      this.importeValorElegido = 0;
      this.cantidadValorElegido = 0;
      this.esPagoElectronico = false;
      this.metodoPagoCambiado = false;
      const formaPago = this.clienteObject.forma_pago;
      const existeTipoValor = this.dtValorElegido.some(
        (element) =>
          element.descripcion_tipo_valor === "Efectivo" ||
          element.descripcion_tipo_valor.startsWith("Cheque") // Verifica si comienza con "Cheque"
      );

      this.esPagoElectronico = !existeTipoValor;

      if (formaPago === "Electronico") {
        if (this.esPagoElectronico) {
          this.metodoPagoCambiado = false;
        } else {
          this.metodoPagoCambiado = true;
        }
      }
      /*
      if (formaPago === "No Electronico") {
        if (this.esPagoElectronico) {
          this.metodoPagoCambiado = true;
        } else {
          this.metodoPagoCambiado = false;
        }
      }
*/
      this.dtValorElegido.forEach((element) => {
        this.importeValorElegido =
          this.importeValorElegido + parseFloat(element.monto);
        this.cantidadValorElegido += 1;
      });
      this.importeValorElegido = this.redondear(this.importeValorElegido);
      this.cantidadValorElegido == 0
        ? (this.detailValorElegido = "Sin pagos seleccionados")
        : (this.detailValorElegido =
            this.cantidadValorElegido +
            (this.cantidadValorElegido === 1 ? " pago = " : " pagos = ") +
            this.$formatoNumero(this.importeValorElegido) +
            " Bs.");
    },

    selectAllDocumentoLista() {
      this.selectedDocLista = [];
      this.selectedDocumentoLista = [];

      //seleccionamos todos los items de la lista de documentos y los marcamos como activos
      this.dtDocumentoLista.forEach((element, index) => {
        this.selectedDocLista.push(element);
        this.selectedDocumentoLista.push(index);
      });
      this.fnDetalleDocumentoLista();
    },

    selectNoneDocumentoLista() {
      this.selectedDocLista = [];
      this.selectedDocumentoLista = [];
      //this.dtDocumentoLista=[];

      this.importeDocumentoLista = 0;
      this.cantidadDocumentoLista = 0;
      this.detailDocumentoLista = "Sin documentos seleccionados";
    },

    editDocumento(active, item, index, origen) {
      if (origen === "Lista") {
        this.selectedDocumentoLista.push(index);
        this.showDetailDocumentoLista(!active, item, index);
      }

      this.formDocCodigo = item.codigo;
      this.formDocDescripcion = item.descripcion;
      this.formDocTipo = item.compro_tipo;

      this.formDocImporte = this.$formatoNumero(item.importe);

      this.formDocFecha = item.fecha;
      this.formDocSaldo = this.$formatoNumero(item.saldo);

      this.formDocSubtotal = this.$formatoNumero(item.subtotal);

      this.formDocOrigen = origen;
      this.dialogIota = true;
    },
    editValorLista(active, item, index, origen) {
      if (origen === "Lista") {
        this.selectedValorLista.push(index);
        this.showDetailValorLista(!active, item, index);
      }
      this.formValorTipo = item.id_tipo_valor;
      this.mostrarDetallesTipoValor();
      this.formValorId = item.id;
      this.formValorCodigo = item.codigo;

      this.formValorBanco = item.id_banco;
      this.formValorBancoDestino = item.id_banco_destino;
      this.formValorMoneda = item.moneda;

      this.formValorImporte = this.$formatoNumero(item.monto);
      this.formValorOrdenante = item.ordenante;
      this.formValorFecha = item.fecha;
      this.formValorFechaDeposito = item.fecha_deposito;

      this.formValorEditado = true;
      this.dialogLambda = true;
    },

    selectValores(banca, tipo) {
      let me = this;
      axios
        .get("api/valores/select/" + banca + "/" + tipo)
        .then(function (response) {
          me.itemsFormValorTipo = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },
    selectBancos(origen) {
      let me = this;
      axios
        .get("api/bancos/select/" + origen)
        .then(function (response) {
          me.itemsFormValorBanco = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },
    selectDirecciones() {
      let me = this;
      axios
        .get("api/direcciones/selectDireccion/" + me.clienteObject.codigo)
        .then(function (response) {
          me.itemsFormFiltroDocumentoDireccion = response.data;

          //agregagamos una direccion con el id 0 al inicio de la lista
          me.itemsFormFiltroDocumentoDireccion.unshift({
            id: "0",
            descripcion: "Todas",
          });
          me.formFiltroDocumentoDireccion = "0";
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },
    selectTalonarios() {
      let me = this;

      axios
        .get("api/talonarios/select/" + this.idUsuario)
        .then(function (response) {
          me.itemsTalonarioRecibo = response.data;
          if (me.itemsTalonarioRecibo.length == 0) {
            me.searchCodClienteFlag = false;
            me.$store.dispatch("setSnackbar", {
              text: "No hay talonarios asignados al usuario.",
              color: "error",
            });
          }
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },

    obtenerDetallesRecibo(item) {
      let me = this;

      me.numero_recibo = item.numero_recibo;

      axios
        .get("api/valor_documentos/ListarPorRecibo/" + item.id)
        .then(function (response) {
          me.dtValorElegido = response.data;
          axios
            .get("api/documentos/ListarPorRecibo/" + item.id)
            .then(function (response) {
              me.dtDocumentoElegido = response.data;
            })
            .catch(function (error) {
              me.$store.dispatch("setSnackbar", {
                text:
                  error == "Error: Network Error"
                    ? "No se pudo conectar con el servidor"
                    : error,
                color: "error",
              });
            });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },

    editValor(item, index) {
      //this.selectedValor.push(index);
      this.formValorId = item.id;
      this.formValorCodigo = item.codigo;
      this.formValorTipo = item.id_tipo_valor;
      this.mostrarDetallesTipoValor();

      this.formValorBanco = item.id_banco;
      this.formValorBancoDestino = item.id_banco_destino;
      this.formValorMoneda = item.moneda;

      this.formValorImporte = this.$formatoNumero(item.monto);
      this.formValorOrdenante = item.ordenante;
      this.formValorFecha = this.$formatoFecha(item.fecha);
      this.formValorFechaDeposito = this.$formatoFecha(item.fecha_deposito);
      this.formValorEditado = true;
      this.dialogLambda = true;
    },

    listarDocumentos() {
      let me = this;
      me.loadGenerico = true;

      var filtroFecha =
        me.formFiltroFecha === null || me.formFiltroFecha === ""
          ? "0"
          : me.formFiltroFecha;
      var filtroFechaVence =
        me.formFiltroFechaVence === null || me.formFiltroFechaVence === ""
          ? "0"
          : me.formFiltroFechaVence;

      var clienteCodigo =
        me.clienteObject.codigo === null || me.clienteObject.codigo === ""
          ? "0"
          : me.clienteObject.codigo;
      var tipoDoc =
        me.formFiltroDocumentoTipo === null || me.formFiltroDocumentoTipo === ""
          ? "0"
          : me.formFiltroDocumentoTipo;
      var fechaDesde =
        me.formFiltroFechaDesde === null || me.formFiltroFechaDesde === ""
          ? "1900-01-01"
          : me.formFiltroFechaDesde;
      var fechaHasta =
        me.formFiltroFechaHasta === null || me.formFiltroFechaHasta === ""
          ? "1900-01-01"
          : me.formFiltroFechaHasta;
      var montoDesde =
        me.formFiltroMontoDesde === null || me.formFiltroMontoDesde === ""
          ? "0"
          : me.formFiltroMontoDesde;
      var montoHasta =
        me.formFiltroMontoHasta === null || me.formFiltroMontoHasta === ""
          ? "0"
          : me.formFiltroMontoHasta;
      var fechaVenceDesde =
        me.formFiltroFechaVenceDesde === null ||
        me.formFiltroFechaVenceDesde === ""
          ? "1900-01-01"
          : me.formFiltroFechaVenceDesde;
      var fechaVenceHasta =
        me.formFiltroFechaVenceHasta === null ||
        me.formFiltroFechaVenceHasta === ""
          ? "1900-01-01"
          : me.formFiltroFechaVenceHasta;

      var idDireccion =
        me.formFiltroDocumentoDireccion === null ||
        me.formFiltroDocumentoDireccion === ""
          ? "0"
          : me.formFiltroDocumentoDireccion;

      axios
        .get(
          "api/documentos/listar/" +
            filtroFecha +
            "/" +
            filtroFechaVence +
            "/" +
            clienteCodigo +
            "/" +
            tipoDoc +
            "/" +
            fechaDesde +
            "/" +
            fechaHasta +
            "/" +
            fechaVenceDesde +
            "/" +
            fechaVenceHasta +
            "/" +
            montoDesde +
            "/" +
            montoHasta +
            "/" +
            idDireccion +
            "/" +
            me.usuario
        )
        .then(function (response) {
          me.dtDocumentoLista = response.data;
          //borramos los elementos que ya estén en dtdocumentoElegido
          me.dtDocumentoLista = me.dtDocumentoLista.filter(
            (item) =>
              !me.dtDocumentoElegido.some((item2) => item.id === item2.id)
          );
          me.loadGenerico = false;
        })
        .catch(function (error) {
          me.loadGenerico = false;
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },
    listarValores() {
      let me = this;

      var clienteId =
        me.clienteObject.id === null || me.clienteObject.id === ""
          ? "0"
          : me.clienteObject.id;

      var tipoDoc =
        me.formFiltroValorTipo === null || me.formFiltroValorTipo === ""
          ? "0"
          : me.formFiltroValorTipo;

      var fechaDesde =
        me.formFiltroFechaDesde === null || me.formFiltroFechaDesde === ""
          ? "1900-01-01"
          : me.formFiltroFechaDesde;

      var fechaHasta =
        me.formFiltroFechaHasta === null || me.formFiltroFechaHasta === ""
          ? "1900-01-01"
          : me.formFiltroFechaHasta;

      var montoDesde =
        me.formFiltroMontoDesde === null || me.formFiltroMontoDesde === ""
          ? "0"
          : me.formFiltroMontoDesde;

      var montoHasta =
        me.formFiltroMontoHasta === null || me.formFiltroMontoHasta === ""
          ? "0"
          : me.formFiltroMontoHasta;

      axios
        .get(
          "api/valor_documentos/listar/" +
            clienteId +
            "/" +
            tipoDoc +
            "/" +
            fechaDesde +
            "/" +
            fechaHasta +
            "/" +
            montoDesde +
            "/" +
            montoHasta +
            "/" +
            me.usuario
        )
        .then(function (response) {
          me.dtValorLista = response.data;

          //this.selectedValorLista.push(index);

          //actualizamos los elementos de dtValorElegido
          me.dtValorElegido.forEach((item) => {
            me.dtValorLista.forEach((item2) => {
              if (item.id === item2.id) {
                item.monto = item2.monto;
                item.fecha = item2.fecha;
                item.id_banco = item2.id_banco;
                item.moneda = item2.moneda;
                item.id_tipo_valor = item2.id_tipo_valor;
              }
            });
          });

          //borramos los elementos que ya estén en dtdocumentoElegido
          me.dtValorLista = me.dtValorLista.filter(
            (item) => !me.dtValorElegido.some((item2) => item.id === item2.id)
          );
          me.fnDetalleValorElegido();
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },

    saveEditDocumentoLista() {
      var subtotal = parseFloat(this.quitarformatoNumero(this.formDocSubtotal));

      var subtotalOriginal = parseFloat(
        this.quitarformatoNumero(this.formDocSaldo)
      );
      var st = Math.abs(subtotal);
      var sto = Math.abs(subtotalOriginal);

      var esFactura = this.formDocTipo === "F" ? true : false;

      if (sto < st) {
        this.$store.dispatch("setSnackbar", {
          text: "El monto ingresado no puede ser mayor al saldo disponible",
          color: "error",
        });
        return;
      }
      subtotal = esFactura ? Math.abs(subtotal) : Math.abs(subtotal) * -1;

      this.dialogIota = false;

      if (this.formDocOrigen === "Lista") {
        var index = this.filtrarDtDocumentoLista.findIndex(
          (i) => i.codigo === this.formDocCodigo
        );
        this.filtrarDtDocumentoLista[index].subtotal = subtotal;
        index = this.selectedDocLista.findIndex(
          (i) => i.codigo === this.formDocCodigo
        );
        this.selectedDocLista[index].subtotal = subtotal;
        this.importeDocumentoLista = 0;
        this.cantidadDocumentoLista = 0;
        this.selectedDocLista.forEach((element) => {
          this.importeDocumentoLista =
            this.importeDocumentoLista + parseFloat(element.subtotal);
          this.cantidadDocumentoLista += 1;
        });
        this.importeDocumentoLista = this.redondear(this.importeDocumentoLista);

        this.cantidadDocumentoLista == 0
          ? (this.detailDocumentoLista = "Sin documentos seleccionados")
          : (this.detailDocumentoLista =
              this.cantidadDocumentoLista +
              (this.cantidadDocumentoLista === 1
                ? " documento = "
                : " documentos = ") +
              this.$formatoNumero(this.importeDocumentoLista) +
              " Bs.");
      } else {
        var index = this.dtDocumentoElegido.findIndex(
          (i) => i.codigo === this.formDocCodigo
        );
        this.dtDocumentoElegido[index].subtotal = subtotal;

        this.fnDetalleDocumentoElegido();
      }

      this.formDocCodigo = "";
      this.formDocDescripcion = "";
      this.formDocImporte = "";
      this.formDocFecha = "";
      this.formDocSaldo = "";
      this.formDocSubtotal = "";
      this.formDocOrigen = "";
    },

    deleteDocumentoElegido(item) {
      let indice = this.dtDocumentoElegido.findIndex(
        (i) => i.codigo === item.codigo
      );
      this.dtDocumentoElegido.splice(indice, 1);
      this.dtDocumentoLista.unshift(item);
      this.importeDocumentoElegido = 0;
      this.cantidadDocumentoElegido = 0;
      this.dtDocumentoElegido.forEach((element) => {
        this.importeDocumentoElegido =
          this.importeDocumentoElegido + parseFloat(element.subtotal);
        this.cantidadDocumentoElegido += 1;
      });
      this.importeDocumentoElegido = this.redondear(
        this.importeDocumentoElegido
      );

      this.cantidadDocumentoElegido == 0
        ? (this.detailDocumentoElegido = "Sin documentos seleccionados")
        : (this.detailDocumentoElegido =
            this.cantidadDocumentoElegido +
            (this.cantidadDocumentoElegido === 1
              ? " documento = "
              : " documentos = ") +
            this.$formatoNumero(this.importeDocumentoElegido) +
            " Bs.");
    },
    deleteValorElegido(item) {
      let indice = this.dtValorElegido.findIndex((i) => i.id === item.id);
      this.dtValorElegido.splice(indice, 1);
      this.fnDetalleValorElegido();

      this.eliminarValoresDocumento();
    },

    deleteValorLista(item) {
      let indice = this.dtValorLista.findIndex((i) => i.id === item.id);
      this.dtValorLista.splice(indice, 1);
      this.importeValorLista = 0;
      this.cantidadValorLista = 0;
      this.dtValorLista.forEach((element) => {
        this.importeValorLista =
          this.importeValorLista + parseFloat(element.monto);
        this.cantidadValorLista += 1;
      });

      this.cantidadValorLista == 0
        ? (this.detailValorLista = "Sin medios de pago seleccionados")
        : (this.detailValorLista =
            this.cantidadValorLista +
            (this.cantidadValorLista === 1
              ? " medio de pago = "
              : " medios de pago = ") +
            this.$formatoNumero(this.importeValorLista) +
            " Bs.");
    },

    closeDocumentoElegido() {
      this.dialogGamma = false;
      this.documentoRecibo = this.detailDocumentoElegido;
      this.calcularBalance();
    },

    closeFiltroDocumento() {
      this.dialogMu = false;
      this.flagFiltroDoc = false;
      this.clearFiltroDocumento();
      this.listarDocumentos();
    },
    clearFiltroDocumento() {
      this.formFiltroMontoDesde = "";
      this.formFiltroDocumentoTipo = "";
      this.formFiltroFecha = "";
      this.formFiltroFechaVence = "";
      this.formFiltroMontoHasta = "";
      this.formFiltroFecha = "";
      this.formFiltroFechaDesde = "";
      this.formFiltroFechaHasta = "";
      this.formFiltroFechaVence = "";
      this.formFiltroFechaVenceDesde = "";
      this.formFiltroFechaVenceHasta = "";
    },
    closeFiltroValor() {
      this.dialogXi = false;
      this.formFiltroMontoDesde = "";
      this.formFiltroMontoHasta = "";
      this.formFiltroFechaDesde = "";
      this.formFiltroFechaHasta = "";

      this.flagFiltroVal = false;
      this.listarValores();
    },
    filtrarDocumentos() {
      this.listarDocumentos();
      this.dialogMu = false;
      this.flagFiltroDoc = true;
    },
    filtrarValores() {
      this.listarValores();
      this.dialogXi = false;
      this.flagFiltroVal = true;
    },

    closeDocumentoLista() {
      this.dialogDelta = false;
      this.selectedDocLista = [];
      this.selectedDocumentoLista = [];
      this.dtDocumentoLista = [];

      this.importeDocumentoLista = 0;
      this.cantidadDocumentoLista = 0;
      this.detailDocumentoLista = "Sin documentos seleccionados";
    },
    closeValorLista() {
      this.dialogNu = false;
      this.selectedValLista = [];
      this.selectedValorLista = [];
      this.dtValorLista = [];

      this.importeValorLista = 0;
      this.cantidadValorLista = 0;
      this.detailValorLista = "Sin pagos seleccionados";
    },

    closeDocumentoListaDetalle() {
      this.formDocCodigo = "";
      this.formDocDescripcion = "";
      this.formDocImporte = "";

      this.formDocSubtotal = "";
      this.dialogIota = false;
    },

    cancelFecha() {
      let me = this;
      me.formValorFecha = this.modalFecha = false;
      //poner fecha actual
      me.formValorFecha = this.$formatoFecha(new Date());
    },
    cancelFechaDeposito() {
      let me = this;
      me.formValorFechaDeposito = this.modalFechaDeposito = false;
      //poner fecha actual
      me.formValorFechaDeposito = this.$formatoFecha(new Date());
    },
    setFecha() {
      let me = this;
      //validar fecha no mayor a 30 dias
      let fecha = new Date(me.formValorFecha);
      let fechaActual = new Date();
      let fechaMaxima = new Date();
      let fechaAnt = new Date();
      fechaMaxima.setDate(fechaActual.getUTCDate());

      if (fecha > fechaMaxima) {
        this.$store.dispatch("setSnackbar", {
          text: "La fecha no puede ser mayor a la fecha actual.",
          color: "error",
        });
        return;
      }

      if (this.valorTipoTipo == 3) {
        fechaAnt.setDate(fechaActual.getUTCDate() - 30);
        if (fecha < fechaAnt) {
          this.$store.dispatch("setSnackbar", {
            text: "La fecha no puede ser menor a 30 días.",
            color: "error",
          });
          return;
        }
      }

      //me.formValorFecha=this.$formatoFechaSpanish(me.formValorFecha);
      me.modalFecha = false;
    },

    setFechaDeposito() {
      let me = this;
      let fecha = new Date(me.formValorFechaDeposito);
      let fechaActual = new Date();

      // Lista de feriados fijos (Formato: 'MM-DD')
      let feriadosFijos = [
        "01-01",
        "01-22",
        "05-01",
        "06-19",
        "06-21",
        "08-06",
        "11-02",
        "12-25",
      ];

      // Función para calcular el Domingo de Pascua
      function getDomingoPascua(año) {
        let A = año % 19;
        let B = Math.floor(año / 100);
        let C = año % 100;
        let D = Math.floor(B / 4);
        let E = B % 4;
        let F = Math.floor((B + 8) / 25);
        let G = Math.floor((B - F + 1) / 3);
        let H = (19 * A + B - D - G + 15) % 30;
        let I = Math.floor(C / 4);
        let K = C % 4;
        let L = (32 + 2 * E + 2 * I - H - K) % 7;
        let M = Math.floor((A + 11 * H + 22 * L) / 451);
        let mes = Math.floor((H + L - 7 * M + 114) / 31);
        let dia = ((H + L - 7 * M + 114) % 31) + 1;
        return new Date(año, mes - 1, dia); // Domingo de Pascua
      }

      // Obtener Domingo de Pascua para el año actual
      let año = fecha.getUTCFullYear();
      let domingoPascua = getDomingoPascua(año);

      // **Semana Santa**
      let juevesSanto = new Date(domingoPascua);
      let viernesSanto = new Date(domingoPascua);
      juevesSanto.setDate(domingoPascua.getUTCDate() - 3);
      viernesSanto.setDate(domingoPascua.getUTCDate() - 2);

      // **Carnaval (Lunes y Martes)**
      let miercolesCeniza = new Date(domingoPascua);
      miercolesCeniza.setDate(domingoPascua.getUTCDate() - 46);
      let martesCarnaval = new Date(miercolesCeniza);
      let lunesCarnaval = new Date(miercolesCeniza);
      martesCarnaval.setDate(miercolesCeniza.getUTCDate() - 1);
      lunesCarnaval.setDate(miercolesCeniza.getUTCDate() - 2);

      // Convertir fechas a 'MM-DD'
      let feriadosDinamicos = [
        `${String(viernesSanto.getUTCMonth() + 1).padStart(2, "0")}-${String(
          viernesSanto.getUTCDate()
        ).padStart(2, "0")}`,
        `${String(lunesCarnaval.getUTCMonth() + 1).padStart(2, "0")}-${String(
          lunesCarnaval.getUTCDate()
        ).padStart(2, "0")}`,
        `${String(martesCarnaval.getUTCMonth() + 1).padStart(2, "0")}-${String(
          martesCarnaval.getUTCDate()
        ).padStart(2, "0")}`,
      ];

      // Unir feriados fijos y dinámicos
      let feriados = [...feriadosFijos, ...feriadosDinamicos];

      // Función para verificar si la fecha es fin de semana o feriado
      function esDiaInvalido(fecha) {
        let diaSemana = fecha.getUTCDay(); // 0 = Domingo, 6 = Sábado
        let mesDia = `${String(fecha.getUTCMonth() + 1).padStart(
          2,
          "0"
        )}-${String(fecha.getUTCDate()).padStart(2, "0")}`;

        return diaSemana === 0 || diaSemana === 6 || feriados.includes(mesDia);
      }

      // Calcular la fecha máxima permitida (2 días después de hoy)
      let fechaMaxima = new Date(fechaActual);
      fechaMaxima.setDate(fechaActual.getUTCDate() + 1);

      // Si la fecha seleccionada es mayor a la fecha máxima
      if (fecha > fechaMaxima) {
        this.$store.dispatch("setSnackbar", {
          text: "La fecha no puede ser superior a un día a partir de hoy.",
          color: "error",
        });
        return;
      }

      // Si la fecha está en fin de semana o es feriado, buscar la siguiente fecha hábil
      while (esDiaInvalido(fecha)) {
        fecha.setDate(fecha.getDate() + 1);
      }

      // Mostrar alerta si la fecha cambió
      if (fecha.getTime() !== new Date(me.formValorFechaDeposito).getTime()) {
        this.$store.dispatch("setSnackbar", {
          text: `La fecha seleccionada era inválida, se ajustó a la siguiente fecha válida disponible.`,
          color: "warning",
        });
      }

      // Actualizar la fecha en el formulario
      me.formValorFechaDeposito = fecha.toISOString().split("T")[0];

      me.modalFechaDeposito = false;
    },

    setFechaDeposito2() {
      let me = this;
      let fecha = new Date(me.formValorFechaDeposito);
      let fechaActual = new Date();

      // Lista de feriados fijos (Formato: 'MM-DD')
      let feriadosFijos = [
        "01-01",
        "01-22",
        "05-01",
        "06-19",
        "06-21",
        "08-06",
        "11-02",
        "12-25",
      ];

      // Función para calcular el Domingo de Pascua (Semana Santa depende de esta fecha)
      function getDomingoPascua(año) {
        let A = año % 19;
        let B = Math.floor(año / 100);
        let C = año % 100;
        let D = Math.floor(B / 4);
        let E = B % 4;
        let F = Math.floor((B + 8) / 25);
        let G = Math.floor((B - F + 1) / 3);
        let H = (19 * A + B - D - G + 15) % 30;
        let I = Math.floor(C / 4);
        let K = C % 4;
        let L = (32 + 2 * E + 2 * I - H - K) % 7;
        let M = Math.floor((A + 11 * H + 22 * L) / 451);
        let mes = Math.floor((H + L - 7 * M + 114) / 31);
        let dia = ((H + L - 7 * M + 114) % 31) + 1;
        return new Date(año, mes - 1, dia); // Domingo de Pascua
      }

      // Obtener Domingo de Pascua para el año actual
      let año = fecha.getUTCFullYear();
      let domingoPascua = getDomingoPascua(año);

      // **Semana Santa**
      let juevesSanto = new Date(domingoPascua);
      let viernesSanto = new Date(domingoPascua);
      juevesSanto.setDate(domingoPascua.getUTCDate() - 3);
      viernesSanto.setDate(domingoPascua.getUTCDate() - 2);

      // **Carnaval (Lunes y Martes)**
      let miercolesCeniza = new Date(domingoPascua);
      miercolesCeniza.setDate(domingoPascua.getUTCDate() - 46);
      let martesCarnaval = new Date(miercolesCeniza);
      let lunesCarnaval = new Date(miercolesCeniza);
      martesCarnaval.setDate(miercolesCeniza.getUTCDate() - 1);
      lunesCarnaval.setDate(miercolesCeniza.getUTCDate() - 2);

      // Convertir fechas a 'MM-DD'
      let feriadosDinamicos = [
        `${String(viernesSanto.getUTCMonth() + 1).padStart(2, "0")}-${String(
          viernesSanto.getUTCDate()
        ).padStart(2, "0")}`,
        `${String(lunesCarnaval.getUTCMonth() + 1).padStart(2, "0")}-${String(
          lunesCarnaval.getUTCDate()
        ).padStart(2, "0")}`,
        `${String(martesCarnaval.getUTCMonth() + 1).padStart(2, "0")}-${String(
          martesCarnaval.getUTCDate()
        ).padStart(2, "0")}`,
      ];

      // Unir feriados fijos y dinámicos
      let feriados = [...feriadosFijos, ...feriadosDinamicos];

      // Función para verificar si la fecha es fin de semana o feriado
      function esDiaInvalido(fecha) {
        let diaSemana = fecha.getUTCDay(); // 0 = Domingo, 6 = Sábado
        let mesDia = `${String(fecha.getUTCMonth() + 1).padStart(
          2,
          "0"
        )}-${String(fecha.getUTCDate()).padStart(2, "0")}`;

        return diaSemana === 0 || diaSemana === 6 || feriados.includes(mesDia);
      }

      // Validar que la fecha no sea un fin de semana ni un feriado
      if (esDiaInvalido(fecha)) {
        this.$store.dispatch("setSnackbar", {
          text: "La fecha seleccionada no puede ser un fin de semana ni un día feriado.",
          color: "error",
        });
        return;
      }

      me.modalFechaDeposito = false;
    },

    closeValorElegido() {
      this.dialogKappa = false;
      this.valorRecibo = this.detailValorElegido;
      this.calcularBalance();
    },

    closeValorDetalle() {
      this.dialogLambda = false;
    },

    addDocumento() {
      this.dialogDelta = true;
      this.listarDocumentos();
    },
    showListaValores() {
      this.listarValores();
      this.dialogNu = true;
    },
    addValor(origen, item) {
      this.dialogLambda = true;
      this.formValorEditado = false;
      //this.cleanValor();
      if (item != null) {
        this.clienteObject = item;

        this.clienteObject.id = item.id;
      }
      if (origen == "T") {
        this.formValorTipo = 1;
        this.mostrarDetallesTipoValor();
        this.selectValores(1, origen);
      } else {
        this.formValorImporte = this.$formatoNumero(
          this.importeDocumentoElegido - this.importeValorElegido
        );
        this.selectValores(this.bancarizacion, origen);
      }

      this.selectBancos(origen);
    },

    obtenerFechaActualEnFormato() {
      const fecha = new Date();
      return fecha.toISOString().slice(0, 10) + "T00:00:00";
    },

    saveValor() {
      let me = this;
      me.loadButton = true;
      var fechaActual = this.obtenerFechaActualEnFormato();
      var fechaAValidar = this.showFechaValor
        ? this.formValorFecha
        : fechaActual;

      if (!this.verificarFechaValores(this.dtValorElegido, fechaAValidar)) {
        this.$store.dispatch("setSnackbar", {
          text: "No se pueden ingresar medios de pago con fechas diferentes.",
          color: "error",
        });
        return;
      }

      if (this.validarValor() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }

      this.formValorImporte = this.quitarformatoNumero(this.formValorImporte);

      if (this.formValorImporte < 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Debe ingresar un valor válido.",
          color: "error",
        });
        return;
      }

      const formData = new FormData();
      formData.append("codigo", this.formValorCodigo);
      formData.append("id_tipo_valor", this.formValorTipo);
      formData.append("id_cliente", this.clienteObject.id);
      formData.append("id_banco", this.showBanco ? this.formValorBanco : "");
      formData.append("fecha", this.showFechaValor ? this.formValorFecha : "");
      formData.append("monto", this.formValorImporte);
      formData.append("moneda", this.formValorMoneda);
      formData.append("usuario", this.usuario);
      formData.append(
        "id_banco_destino",
        this.valorTipoTipo == 3 ? this.formValorBancoDestino : ""
      );
      formData.append("ordenante", this.formValorOrdenante);
      formData.append(
        "fecha_deposito",
        this.valorTipoTipo == 3 ? this.formValorFechaDeposito : ""
      );
      if (this.showBanco) {
        if (this.selectedFile != null) {
          formData.append("subido", this.selectedFile);
        } else {
          this.$store.dispatch("setSnackbar", {
            text: "Debe seleccionar un archivo.",
            color: "error",
          });
          return;
        }
      } else {
        formData.append("subido", "");
      }

      
      if (this.formValorEditado) {
        formData.append("id", this.formValorId);

        axios
          .put("api/valor_documentos/actualizar", formData)
          .then(function (response) {
            me.$store.dispatch("setSnackbar", {
              text: "Medio de pago creado exitosamente ",
              color: "success",
            });
            me.listarValores();

            me.cleanValor();
            me.dialogLambda = false;
            me.loadButton = false;
          })
          .catch(function (error) {
            me.loadButton = false;
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      } else {
        axios
          .post("api/valor_documentos/crear", formData)
          .then(function (response) {
            me.$store.dispatch("setSnackbar", {
              text: "Medio de pago creado exitosamente ",
              color: "success",
            });
            me.listarValores();
            me.fnDetalleValorElegido();
            me.dialogLambda = false;
            me.loadButton = false;

            if (me.formValorTipo != 1) {
              me.dtValorElegido.push(response.data[0]);
              me.cleanValor();
            } else {
              axios
                .post("api/valor_documentos/MandarMailTransferencia", formData)
                .then(function (response) {
                  me.cleanValor();
                  me.listarClientes();
                  me.loadButton = false;
                  me.$store.dispatch("setSnackbar", {
                    text: "Notificación enviada. ",
                    color: "success",
                  });
                })
                .catch(function (error) {
                  me.$store.dispatch("setSnackbar", {
                    text: error.response.data,
                    color: "error",
                  });
                });
            }
          })
          .catch(function (error) {
            me.loadButton = false;
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      }
    },

    cleanValor() {
      this.formValorId = 0;

      this.formValorTipo = "";

      this.mostrarDetallesTipoValor();

      this.formValorCodigo = "";

      this.formValorImporte = "";

      this.ordenante = "";

      this.formValorFecha = "";
      this.formValorFechaDeposito = "";

      this.formValorMoneda = "Bs.";

      this.cantidadValor = 0;

      this.fileValor = null;

      this.selectedFile = null;
      this.importeValorLista = 0;
      this.importeValorElegido = 0;
      this.detailValorLista = "Sin medios de pago seleccionados";
      this.detailValorElegido = "Sin medios de pago seleccionados";
      this.dtValorLista = [];
    },

    saveRecibo() {
      let me = this;
      if (this.validarRecibo() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }
      var ajuste = me.tipoAjusteRecibo ? me.ajusteRecibo : me.ajusteRecibo * -1;
      me.loadButton = true;
      axios
        .post("api/recibos/crear", {
          observacion: me.descripcionRecibo,
          fecha: me.fechaRecibo,
          id_cliente: me.clienteObject.id,
          documentos: me.dtDocumentoElegido,
          ajuste: ajuste,
          latitud: me.location.latitude,
          longitud: me.location.longitude,
          valores: me.dtValorElegido,
          talonario: me.talonarioRecibo,
          usuario: me.usuario,
        })
        .then(function (response) {
          me.generarPDF();
          //me.closeRecibo();
          //me.listarClientes();
          //me.loadButton=false;

          me.$store.dispatch("setSnackbar", {
            text:
              "Recibo creado exitosamente. Se generó el recibo N° " +
              response.data,
            color: "success",
          });
          setTimeout(function () {
            window.location.reload();
          }, 3000);
        })
        .catch(function (error) {
          console.error(error);
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
          me.loadButton = false;
        });
    },
    anularRecibo() {
      let me = this;

      axios
        .put("api/recibos/anular/" + me.idRecibo + "/" + me.usuario, {})
        .then(function (response) {
          me.generarPDF();
          me.closeRecibo();
          me.$store.dispatch("setSnackbar", {
            text: "Recibo anulado exitosamente" + response.data,
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },
    eliminarValoresDocumento() {
      let me = this;
      axios
        .put(
          "api/valor_documentos/EliminarValoresDocumento/" +
            me.usuario +
            "/" +
            me.clienteObject.id,
          {}
        )
        .then(function (response) {})
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },
    calcularBalance() {
      var doc = parseFloat(this.importeDocumentoElegido);
      var val = parseFloat(this.importeValorElegido);
      var ajuste = this.tipoAjusteRecibo
        ? parseFloat(this.ajusteRecibo)
        : parseFloat(this.ajusteRecibo) * -1;

      this.balanceRecibo = val - doc + ajuste;
      this.balanceRecibo = this.$formatoNumero(this.balanceRecibo);
    },

    showValores() {
      this.dialogKappa = true;
      if (
        this.importeValor === 0 ||
        this.importeValor === null ||
        this.importeValor === undefined ||
        this.importeValor === ""
      ) {
        //this.showListaValores()
        //this.formValorImporte = this.importeDocumentoElegido;
      }
    },

    redondear(num) {
      var res = 0;
      if (num < 0.000001 && num > -0.000001) res = 0;
      else res = +(Math.round(num + "e+2") + "e-2");

      return res;
    },

    quitarformatoNumero(num) {
      var n = num.replace(/\./g, "");
      n = n.replace(/\,/g, ".");
      return n;
    },

    estaVencido(fecha) {
      var fechaActual = new Date().setHours(0, 0, 0, 0);
      var fechaVencimiento = new Date(fecha);
      if (fechaActual > fechaVencimiento) {
        return true;
      } else {
        return false;
      }
    },

    mostrarDetallesTipoValor() {
      var me = this;
      if (
        this.formValorTipo == null ||
        this.formValorTipo == undefined ||
        this.formValorTipo == ""
      ) {
        this.valorTipoDescripcion = "";
        this.valorTipoTipo = "";
        this.showBanco = false;
        this.showFechaValor = false;
        return;
      }

      axios
        .get("/api/valores/propiedadesValorTipo/" + this.formValorTipo)
        .then(function (response) {
          var a = response.data.split("|");
          me.valorTipoDescripcion = a[0];
          me.valorTipoTipo = a[1];
          me.showBanco = me.valorTipoTipo == 2 ? false : true;
          me.showFechaValor = me.valorTipoTipo == 2 ? false : true;
        })
        .catch(function (error) {
          console.error(error);
        });
    },

    mostrarDescripcionBanco() {
      var me = this;
      axios
        .get("/api/bancos/descripcionBanco/" + this.formValorBanco)
        .then(function (response) {
          me.descripcionBanco = response.data;
        })
        .catch(function (error) {
          console.error("error2" + error);
        });
    },

    generarPDF() {
      var filasDocumento = this.dtDocumentoElegido.length * 4.65;
      var filasValor = this.dtValorElegido.length * 4.65;
      var quitarFirma = this.esPagoElectronico ? 23 : 0;
      var fechaAct = this.$formatoFechaHoras(new Date(Date.now()));
      var numeroLiteral;
      var monedaSingular = "Boliviano";
      var monedaPlural = "Bolivianos";
      var centavos = "/100";

      var mensajeEntorno =
        this.$ENTORNO == "P" ? "MEGALABS BOLIVIA SRL" 
        : "DOCUMENTO DE PRUEBA";

      numeroLiteral = this.$numerosALetras(
        this.importeValorElegido,

        monedaSingular,
        monedaPlural,
        centavos
      );

      var colValor = ["Medio de Pago", "Importe"];
      var colDocumento = ["Nro Comp", "Subtotal", "Saldo"];

      var rowsValor = [];
      var rowValor = [];
      var rowsDocumento = [];
      var rowDocumento = [];

      var arrValor = this.dtValorElegido;
      var mensajeCheque = "";
      var esCheque = false;

      var j = 0;
      //generación y ordenamiento de VALOR DOCUMENTO
      arrValor.forEach((obj) => {
        let rowValor = [];

        const {
          codigo,
          descripcion_tipo_valor,
          id_tipo_valor,
          monto,
          banco_destino,
          cuenta_destino,
          fecha_deposito,
        } = obj;

        let descripcion =
          descripcion_tipo_valor +
            (id_tipo_valor == "3" ? " Nro." + codigo : "") || "";

        if (id_tipo_valor == "3") {
          mensajeCheque = "Cobranza sujeta a acreditación de cheque.";
          filasValor += 16.65;
          esCheque = true;

          // Agregar información extra con saltos de línea
          descripcion += `\nBanco a Depositar: `;
          descripcion += `\n${banco_destino || "N/A"} (${
            cuenta_destino || "N/A"
          })`;
          descripcion += `\nFecha a Depositar: `;
          descripcion += `\n${
            this.$formatoFechaSpanish(fecha_deposito) || "N/A"
          }`;
        }

        if (descripcion) {
          rowValor.push(descripcion);
        }

        if (monto !== undefined) {
          rowValor.push(this.$formatoNumero(monto));
        }

        rowsValor.push(rowValor);
      });

      var arrDocumento = this.dtDocumentoElegido;

      let subtotal = 0;
      arrDocumento.forEach((obj) => {
        let rowDocumento = [];

        const { codigo, subtotal: sub, saldo } = obj;

        if (codigo !== undefined) {
          rowDocumento.push(codigo);
        }

        if (sub !== undefined) {
          rowDocumento.push(this.$formatoNumero(sub));
          subtotal = sub; // Actualiza el subtotal
        }

        if (saldo !== undefined) {
          rowDocumento.push(this.$formatoNumero(saldo - subtotal));
        }

        rowsDocumento.push(rowDocumento);
      });
      //generación del documento
      var paperHeight = 200 + filasDocumento + filasValor - quitarFirma;
      const doc = new jsPDF("p", "mm", [paperHeight, 80]);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);
      doc.text(mensajeEntorno, 40, 10, null, null, "center");

      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.text("RECIBO N°" + this.codigoRecibo, 40, 20, null, null, "center");
      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");
      doc.text("Fecha: " + fechaAct, 5, 25);
      doc.text("Cobrador:  " + this.nombreUsuario, 5, 30);
      doc.text(
        "Cliente: (" +
          this.clienteObject.codigo +
          ")" +
          this.clienteObject.descripcion,
        5,
        35
      );
      doc.text(
        "Cliente: (" +
          this.clienteObject.codigo +
          ")" +
          this.clienteObject.descripcion,
        5,
        35
      );
      if (this.metodoPagoCambiado) {
        doc.text("Método de pago diferente al acordado", 5, 40, null, null);
      }
      doc.line(5, 45, 75, 45);
      doc.line(5, 50, 75, 50);

      autoTable(doc, {
        head: [colDocumento],
        body: rowsDocumento,
        startY: 45,
        margin: 5,
        theme: "plain",

        styles: { cellPadding: 0.5, fontSize: 9, lineWidth: 0.0 },
        columnStyles: {
          0: { cellWidth: 30 },
          2: { cellWidth: 20, halign: "right" },
          3: { cellWidth: 20, halign: "right" },
        },
      });

      doc.setFontSize(9);
      doc.setFont("helvetica", "bold");
      doc.line(5, 50 + filasDocumento, 75, 50 + filasDocumento);
      doc.text("Total Documentos: ", 5, 55 + filasDocumento);
      doc.text(
        this.$formatoNumero(this.importeDocumentoElegido),

        75,
        55 + filasDocumento,
        null,
        null,
        "right"
      );
      doc.line(5, 70 + filasDocumento, 75, 70 + filasDocumento);
      doc.line(5, 75 + filasDocumento, 75, 75 + filasDocumento);
      autoTable(doc, {
        head: [colValor],
        body: rowsValor,
        margin: 5,
        startY: 70 + filasDocumento,
        theme: "plain",
        styles: {
          cellPadding: 0.5,
          fontSize: 9,
          lineWidth: 0.0,
          overflow: "linebreak", // Permite respetar los saltos de línea en la celda
        },
        columnStyles: {
          0: { cellWidth: 50, whiteSpace: "pre-line" }, // Asegura que los \n se respeten
          1: { cellWidth: 20, halign: "right" },
        },
      });

      doc.setFontSize(9);
      doc.setFont("helvetica", "bold");
      doc.line(
        5,
        75 + filasValor + filasDocumento,
        75,
        75 + filasValor + filasDocumento
      );
      doc.text("Ajuste: ", 5, 80 + filasValor + filasDocumento);
      doc.text(
        this.$formatoNumero(this.ajusteRecibo),
        75,
        80 + filasValor + filasDocumento,
        null,
        null,
        "right"
      );

      doc.text("Total Recibido: ", 5, 85 + filasValor + filasDocumento);
      doc.text(
        this.$formatoNumero(this.importeValorElegido),
        75,
        85 + filasValor + filasDocumento,
        null,
        null,
        "right"
      );
      doc.setFontSize(8);
      doc.setFont("helvetica", "normal");

      doc.text("Son: " + numeroLiteral, 5, 95 + filasValor + filasDocumento, {
        align: "justify",
        lineHeightFactor: 1.5,
        maxWidth: 70,
      });
      doc.setFontSize(9);
      doc.setFont("helvetica", "bold");
      if (!this.esPagoElectronico) {
        doc.text(
          "Firma del Cliente",
          40,
          120 + filasValor + filasDocumento - quitarFirma,
          null,
          null,
          "center"
        );
      }

      doc.setFontSize(8);
      doc.text(
        mensajeCheque,
        40,
        123 + filasValor + filasDocumento - quitarFirma,
        null,
        null,
        "center"
      );

      doc.text(
        "Fecha: " + fechaAct,
        40,
        128 + filasValor + filasDocumento - quitarFirma,
        null,
        null,
        "center"
      );

      doc.text(
        "Cobrador:  " + this.nombreUsuario,
        40,
        133 + filasValor + filasDocumento - quitarFirma,
        null,
        null,
        "center"
      );

      doc.text(
        "Cliente: (" +
          this.clienteObject.codigo +
          ")" +
          this.clienteObject.descripcion,
        40,
        138 + filasValor + filasDocumento - quitarFirma,
        null,
        null,
        "center"
      );

      //generaci+on del codigo qr
      var canvasDiv = document.createElement("div"); //New dom element, if there is only one page, you can use the page element directly

      canvasDiv.id = "canvas";

      this.$refs.qrCodeUrl.append(canvasDiv);

      var qrcode = new QRCode("canvas", {
        //qrcode generates QR code
        text:
          this.clienteObject.codigo +
          "|" +
          this.clienteObject.descripcion +
          "|" +
          this.codigoRecibo +
          "|" +
          this.nombreUsuario +
          "|" +
          fechaAct +
          "|" +
          this.$formatoNumero(this.importeValorElegido) +
          "|" +
          this.$formatoNumero(this.importeDocumentoElegido) +
          "|" +
          this.$formatoNumero(this.ajusteRecibo),

        width: 80,
        height: 80,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.M,
      });

      let canvas = document.getElementById("canvas").querySelector("canvas"); //Get the canvas element

      var dataURL = canvas.toDataURL();

      canvas = null;

      doc.setFontSize(12);

      doc.addImage(
        dataURL,
        "JPEG",
        15,
        140 + filasValor + filasDocumento - quitarFirma,
        50,
        50
      );

      //generamos el documento pdf
      doc.save("Recibo N° " + this.codigoRecibo + ".pdf");
    },

    validarRecibo() {
      this.valida = 0;

      Object.keys(this.formRecibo).forEach((f) => {
        this.$refs[f].validate(true);
        if (this.$refs[f].validate(true)) {
          this.valida += 0;
        } else {
          this.valida += 1;
        }
      });
      var balance = parseFloat(this.quitarformatoNumero(this.balanceRecibo));

      if (this.talonarioRecibo === "0" || this.talonarioRecibo === "") {
        this.valida += 1;
        this.$store.dispatch("setSnackbar", {
          text: "El talonario no está asignado. Contacte al administrador.",
          color: "error",
        });
        return this.valida;
      }

      if (balance != 0) {
        this.valida += 1;
        this.$store.dispatch("setSnackbar", {
          text: "El balance debe ser igual a 0",
          color: "error",
        });
        return this.valida;
      }

      if (this.documentoRecibo == "Sin documentos seleccionados") {
        this.valida += 1;
        this.$store.dispatch("setSnackbar", {
          text: "El balance debe ser igual a 0",
          color: "error",
        });
        return this.valida;
      }

      return this.valida;
    },
    validarValor() {
      this.valida = 0;
      Object.keys(this.formValor).forEach((f) => {
        this.$refs[f].validate(true);
        if (this.$refs[f].validate(true)) {
          this.valida += 0;
        } else {
          this.valida += 1;
        }
      });
      return this.valida;
    },
  },
};
</script>
